// Product Customizer JavaScript - Fixed Version
// Label pricing from PDF
let labelPricing = {
  "Circle": {
    "1": { 10: 12.50, 50: 21.50, 100: 24.50, 150: 25.50, 250: 44.50, 500: 75.50, 1000: 115, 2500: 185, 5000: 350, 10000: 685 },
    "1.5": { 10: 15.50, 50: 21.50, 100: 24.50, 150: 25.50, 250: 45.50, 500: 78.50, 1000: 120, 2500: 195, 5000: 355, 10000: 695 },
    "2": { 10: 20.50, 50: 23.50, 100: 27.50, 150: 29.50, 250: 50.50, 500: 90.50, 1000: 154, 2500: 285, 5000: 495, 10000: 980 },
    "2.5": { 10: 25.50, 50: 43.50, 100: 47.50, 150: 68.50, 250: 95.50, 500: 115, 1000: 175, 2500: 315, 5000: 535, 10000: 995 },
    "3": { 10: 30.50, 50: 48.50, 100: 54.50, 150: 57.50, 250: 90.50, 500: 133, 1000: 230, 2500: 405, 5000: 800, 10000: 1395 },
    "3.5": { 10: 35.50, 50: 49.50, 100: 58.50, 150: 62.50, 250: 97.50, 500: 144, 1000: 244, 2500: 449, 5000: 835, 10000: 1495 },
    "4": { 10: 40.50, 50: 57.50, 100: 67.50, 150: 87.50, 250: 105, 500: 165, 1000: 287, 2500: 485, 5000: 932, 10000: 1695 }
  },
  "Square": {
    "1": { 10: 14.50, 50: 24.50, 100: 27.50, 150: 34.50, 250: 47.50, 500: 80.50, 1000: 115, 2500: 185, 5000: 350, 10000: 685 },
    "1.5": { 10: 17.50, 50: 27.50, 100: 29.50, 150: 37.50, 250: 49.50, 500: 84.50, 1000: 120, 2500: 195, 5000: 355, 10000: 695 },
    "2": { 10: 23.50, 50: 29.50, 100: 34.50, 150: 43.50, 250: 58.50, 500: 95.50, 1000: 154, 2500: 285, 5000: 495, 10000: 980 },
    "2.5": { 10: 29.50, 50: 48.50, 100: 54.50, 150: 74.50, 250: 99.50, 500: 125, 1000: 175, 2500: 315, 5000: 535, 10000: 995 },
    "3": { 10: 35.50, 50: 54.50, 100: 62.50, 150: 78.50, 250: 105, 500: 150, 1000: 230, 2500: 405, 5000: 800, 10000: 1395 },
    "3.5": { 10: 40.50, 50: 59.50, 100: 67.50, 150: 84.50, 250: 115, 500: 157, 1000: 244, 2500: 449, 5000: 835, 10000: 1495 },
    "4": { 10: 47.50, 50: 65.50, 100: 74.50, 150: 95.50, 250: 125, 500: 175, 1000: 287, 2500: 485, 5000: 932, 10000: 1695 }
  },
  "Oval": {
    "3x2": { 10: 35.50, 50: 54.50, 100: 62.50, 150: 78.50, 250: 105, 500: 150, 1000: 230, 2500: 405, 5000: 800, 10000: 1395 },
    "4x2.5": { 10: 47.50, 50: 65.50, 100: 74.50, 150: 95.50, 250: 125, 500: 175, 1000: 287, 2500: 485, 5000: 932, 10000: 1695 }
  },
  "Rectangle": {
    "2.75x1": { 10: 25.50, 50: 45.50, 100: 62.50, 150: 78.50, 250: 105, 500: 150, 1000: 230, 2500: 405, 5000: 800, 10000: 1395 },
    "4x1.5": { 10: 40.50, 50: 45.50, 100: 74.50, 150: 95.50, 250: 125, 500: 175, 1000: 287, 2500: 485, 5000: 932, 10000: 1695 },
    "4x2.5": { 10: 45.50, 50: 50.50, 100: 85.50, 150: 107, 250: 145, 500: 195, 1000: 375, 2500: 565, 5000: 1035, 10000: 1995 },
    "4x3.5": { 10: 57.50, 50: 65.50, 100: 95.50, 150: 115, 250: 155, 500: 205, 1000: 390, 2500: 575, 5000: 1065, 10000: 2025 }
  }
};

// Round to nearest 0.5"
function roundUpToHalfInch(value) {
  return Math.ceil(value * 2) / 2;
}

// Quantity multipliers per size category for STICKERS
let stickerQuantityMultipliers = {
  "1x1": { 50: 1, 75: 1.15, 100: 1.2, 150: 1.6, 250: 3, 300: 3.25, 500: 3.5, 1000: 7, 1750: 9.5, 2500: 12, 5000: 24, 7500: 35.5, 10000: 47 },
  "2x2": { 50: 1, 75: 1.2, 100: 1.34, 150: 2, 250: 3.2, 300: 4, 500: 4.5, 1000: 7.75, 1750: 10.5, 2500: 14, 5000: 27, 7500: 37.5, 10000: 48 },
  "3x3": { 50: 1, 75: 1.65, 100: 1.813, 150: 2.64, 250: 3.25, 300: 4, 500: 5.1, 1000: 8, 1750: 12.25, 2500: 16.5, 5000: 27, 7500: 40.5, 10000: 54 },
  "4x4": { 50: 1, 75: 1.45, 100: 1.563, 150: 2.35, 250: 3.4, 300: 4, 500: 4.6, 1000: 7.75, 1750: 12.25, 2500: 16.25, 5000: 27, 7500: 41, 10000: 55 },
  "5x5": { 50: 1, 75: 1.35, 100: 1.42, 150: 2.14, 250: 2.6, 300: 3.25, 500: 4.25, 1000: 7.5, 1750: 10.5, 2500: 14, 5000: 28, 7500: 38, 10000: 48 },
  "6x6": { 50: 1, 75: 1.65, 100: 1.728, 150: 2.59, 250: 3.72, 300: 4.25, 500: 4.85, 1000: 8.5, 1750: 12.5, 2500: 19, 5000: 29, 7500: 45, 10000: 61 },
  "7x7": { 50: 1, 75: 1.35, 100: 1.46, 150: 2.19, 250: 3, 300: 4, 500: 5.67, 1000: 10.5, 1750: 17.5, 2500: 24.5, 5000: 30, 7500: 44.5, 10000: 61 },
  "8x8": { 50: 1, 75: 1.6, 100: 1.72, 150: 2.59, 250: 4.25, 300: 5.5, 500: 7.71, 1000: 13.5, 1750: 16, 2500: 18.5, 5000: 35, 7500: 52.5, 10000: 70 }
};

let sfPricingConfig = {
  currency: "USD",
  minimum_price: 25,
  enhancement_fee: 2.95,
  sticker: {
    area_rates: [
      { max_area: 6, type: "flat", rate: 0, price_50: 25 },
      { max_area: 9, type: "tiered", rate: 0.084 },
      { max_area: 14, type: "tiered", rate: 0.073 },
      { max_area: 35, type: "tiered", rate: 0.056 },
      { max_area: null, type: "large", rate: 0.048 }
    ],
    quantity_multipliers: stickerQuantityMultipliers,
    laminate_fees: [
      { max_dimension: 2, fee: 2.95 },
      { max_dimension: 3, fee: 4.95 },
      { max_dimension: 4, fee: 7.95 },
      { max_dimension: null, fee: 9.95 }
    ]
  },
  label: {
    gloss_laminate_fee: 1.95,
    holographic_clear_fees: [
      { max_size: 1.5, fee: 9.95 },
      { max_size: 2.5, fee: 14.95 },
      { max_size: null, fee: 19.95 }
    ],
    prices: labelPricing
  }
};

function sfFeeByTier(value, tiers, key) {
  for (const tier of tiers || []) {
    const limit = tier[key];
    if (limit === null || typeof limit === 'undefined' || value <= parseFloat(limit)) {
      return parseFloat(tier.fee || 0);
    }
  }
  return 0;
}

function sfTruthyValue(value) {
  if (typeof value === 'boolean') return value;
  return ['1', 'true', 'yes', 'on', 'enabled'].includes(String(value || '').trim().toLowerCase());
}

function hasSfSizeQtyOverrides() {
  const overrides = { ...readMetafieldOverrides(), ...(window.sfOverrides || {}) };
  return sfTruthyValue(overrides.dealMode) ||
    !!sfCleanOverrideValue(overrides.size) ||
    !!sfCleanOverrideValue(overrides.qty);
}

function isSfLockedBuilderOffer() {
  if (!document.querySelector('.sf-builder-page')) return false;
  const overrides = { ...readMetafieldOverrides(), ...(window.sfOverrides || {}) };
  return sfTruthyValue(overrides.dealMode) ||
    !!sfCleanOverrideValue(overrides.basePrice) ||
    !!sfCleanOverrideValue(overrides.size) ||
    !!sfCleanOverrideValue(overrides.qty);
}

function sfLoadPricingConfig() {
  const endpoint = 'https://dashboard.stickerfreaksllc.com/api/pricing.php';
  fetch(endpoint, { cache: 'no-store', credentials: 'omit' })
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      if (!data || !data.ok || !data.config) return;
      sfPricingConfig = data.config;
      if (sfPricingConfig.label?.prices) labelPricing = sfPricingConfig.label.prices;
      if (sfPricingConfig.sticker?.quantity_multipliers) {
        stickerQuantityMultipliers = sfPricingConfig.sticker.quantity_multipliers;
      }
      updatePriceDisplay();
      updateBuilderSummary();
      updateMaterialPricing();
    })
    .catch(() => {
      // Keep built-in pricing if the dashboard endpoint is unavailable.
    });
}

function getMultiplierKey(roundedSide) {
  return (roundedSide <= 8) ? `${roundedSide}x${roundedSide}` : "8x8";
}

function getQtyMultiplier(qty, sizeKey, productType) {
  const multipliers = stickerQuantityMultipliers[sizeKey];
  return multipliers?.[qty] || null;
}

function getBasePrice(width, height, productType) {
  const area = width * height;
  const bands = sfPricingConfig?.sticker?.area_rates || [];

  for (const band of bands) {
    if (band.max_area === null || area <= parseFloat(band.max_area)) {
      const rate = parseFloat(band.rate || 0);
      return {
        type: band.type || "tiered",
        rate,
        price50: typeof band.price_50 !== 'undefined' && band.price_50 !== null && band.price_50 !== ''
          ? parseFloat(band.price_50)
          : area * 50 * rate
      };
    }
  }

  return { type: "large", rate: 0.048, price50: area * 50 * 0.048 };
}

// Get dimensions from form - FIXED VERSION
function getDimensions() {
  const productType = document.querySelector('input[name="product-type"]:checked')?.value;
  
  if (productType === 'Custom Sticker') {
    const sizeSelect = document.getElementById('select-size-sticker');
    const customWidth = document.getElementById('custom-width-input');
    const customHeight = document.getElementById('custom-height-input');
    
    // FIXED: Only use custom inputs if "Custom Size" is actually selected
    if (sizeSelect && sizeSelect.value === 'Custom Size') {
      // Only use custom inputs when Custom Size is selected
      if (customWidth && customHeight && customWidth.value && customHeight.value) {
        const width = parseFloat(customWidth.value);
        const height = parseFloat(customHeight.value);
        if (width && height) {
          return { width, height };
        }
      }
      return null; // Return null if Custom Size selected but no valid values
    }
    
    // FIXED: Always use dropdown value when not "Custom Size"
    if (sizeSelect && sizeSelect.value && sizeSelect.value !== 'Custom Size') {
      const [width, height] = sizeSelect.value.split(' x ').map(s => parseFloat(s));
      return { width, height };
    }
  } else if (productType === 'Custom Label') {
    const shape = document.querySelector('input[name="properties[Label Shape]"]:checked')?.value;
    if (!shape) return null;
    
    let sizeSelect;
    if (shape === 'Circle') {
      sizeSelect = document.getElementById('select-size-circle-label');
    } else if (shape === 'Square') {
      sizeSelect = document.getElementById('select-size-square-label');
    } else if (shape === 'Oval') {
      sizeSelect = document.getElementById('select-size-oval-label');
    } else if (shape === 'Rectangle') {
      sizeSelect = document.getElementById('select-size-rectangle-label');
    }
    
    if (sizeSelect && sizeSelect.value) {
      if (shape === 'Circle' || shape === 'Square') {
        const size = parseFloat(sizeSelect.value);
        return { width: size, height: size, shape, sizeKey: sizeSelect.value };
      } else {
        // Oval and Rectangle have specific size formats
        return { shape, sizeKey: sizeSelect.value };
      }
    }
  }
  
  return null;
}

// Get quantity from form with better error handling
function getQuantity() {
  const productType = document.querySelector('input[name="product-type"]:checked')?.value;
  
  if (productType === 'Custom Sticker') {
    const quantitySelect = document.getElementById('sticker-quantity');
    if (quantitySelect && quantitySelect.value) {
      const qty = parseInt(quantitySelect.value);
      // console.log(('Sticker quantity found:', qty);
      return qty;
    }
  } else if (productType === 'Custom Label') {
    const quantitySelect = document.getElementById('label-quantity');
    if (quantitySelect && quantitySelect.value) {
      const qty = parseInt(quantitySelect.value);
      // console.log(('Label quantity found:', qty);
      return qty;
    }
  }
  
  // console.log(('⚠️ No quantity found, returning null');
  return null;
}

// Calculate price based on form values
function calculatePrice() {
  const dimensions = getDimensions();
  const qty = getQuantity();
  const productType = document.querySelector('input[name="product-type"]:checked')?.value;



  // Deal mode uses the metafield price as the fixed offer price.
  if (sfTruthyValue(window.sfOverrides?.dealMode) || (typeof window.sfOverrides?.dealMode === 'undefined' && sfTruthyValue(readMetafieldOverrides()?.dealMode))) {
    const overrides = { ...window.sfOverrides, ...readMetafieldOverrides() };
    return parseFloat(overrides.basePrice || 0) || 0;
  }

  
  if (!dimensions || !qty || !productType) {
    return 0;
  }
  
  if (productType === 'Custom Label') {
    // Use label pricing from PDF
    const shape = dimensions.shape;
    const sizeKey = dimensions.sizeKey;
    
    if (labelPricing[shape] && labelPricing[shape][sizeKey] && labelPricing[shape][sizeKey][qty]) {
      let basePrice = labelPricing[shape][sizeKey][qty];
      
      // Add material costs - check label material selector
      const material = document.querySelector('input[name="properties[Label Material]"]:checked')?.value;
      if (material === 'Gloss Laminate') {
        basePrice += parseFloat(sfPricingConfig?.label?.gloss_laminate_fee || 1.95);
      } else if (material === 'Holographic' || material === 'Clear') {
        // Dynamic pricing for Holographic/Clear
        const size = parseFloat(sizeKey);
        basePrice += sfFeeByTier(size, sfPricingConfig?.label?.holographic_clear_fees, 'max_size');
      }
      
      // Add enhancement cost
      const enhanced = document.querySelector('input[name="properties[Enhance Image Quality]"]:checked')?.value;
      if (enhanced === 'Enhanced') {
        basePrice += parseFloat(sfPricingConfig?.enhancement_fee || 2.95);
      }
      
      return basePrice;
    }
    return 0;
  } else {
    // Sticker pricing (existing logic)
    let { width, height } = dimensions;
    
    if (width > 47 || height > 47) {
      return 0; // Max size exceeded
    }
    
    width = roundUpToHalfInch(width);
    height = roundUpToHalfInch(height);
    const area = width * height;
    const roundedSide = Math.max(width, height);
    const sizeKey = getMultiplierKey(Math.ceil(roundedSide));
    
    const base = getBasePrice(width, height, productType);
    let final;
    
    if (qty === 10) {
      final = area * 10 * base.rate;
    } else {
      const multiplier = getQtyMultiplier(qty, sizeKey, productType);
      if (!multiplier) {
        return 0; // Quantity not available for this size
      }
      final = base.price50 * multiplier;
    }
    
    // Add material costs for stickers - UPDATED WITH PRICING TIERS
    const material = document.querySelector('input[name="properties[Select Your Material]"]:checked')?.value;
    if (material === 'Gloss Laminate' || material === 'Matte Laminate') {
      // Calculate material cost based on size tiers
      const maxDimension = Math.max(width, height);
      
      final += sfFeeByTier(maxDimension, sfPricingConfig?.sticker?.laminate_fees, 'max_dimension');
    }
    // Vinyl has no extra cost
    
    // Add enhancement cost
    const enhanced = document.querySelector('input[name="properties[Enhance Image Quality]"]:checked')?.value;
    if (enhanced === 'Enhanced') {
      final += parseFloat(sfPricingConfig?.enhancement_fee || 2.95);
    }
    
    // Minimum price
    const minPrice = parseFloat(sfPricingConfig?.minimum_price || 25);
    if (final < minPrice) final = minPrice;
    
    return final;
  }
}

// Auto-select custom size when user types in custom inputs - ENHANCED WITH ERROR HANDLING
function handleCustomSizeInputs() {
  const customWidth = document.getElementById('custom-width-input');
  const customHeight = document.getElementById('custom-height-input');
  const sizeSelect = document.getElementById('select-size-sticker');
  
  if (customWidth && customHeight && sizeSelect) {
    const handleInput = () => {
      if (customWidth.value || customHeight.value) {
        sizeSelect.value = 'Custom Size';
      }
      
      // Validate custom size inputs
      validateCustomSize();
      updatePriceDisplay();
    };
    
    customWidth.addEventListener('input', handleInput);
    customHeight.addEventListener('input', handleInput);
    
    // Also validate on blur (when user leaves the field)
    customWidth.addEventListener('blur', validateCustomSize);
    customHeight.addEventListener('blur', validateCustomSize);
  }
}

// Validate custom size inputs and show errors
function validateCustomSize() {
  const customWidth = document.getElementById('custom-width-input');
  const customHeight = document.getElementById('custom-height-input');
  const sizeSelect = document.getElementById('select-size-sticker');
  
  // Remove any existing error messages
  removeCustomSizeErrors();
  
  if (sizeSelect && sizeSelect.value === 'Custom Size') {
    const width = parseFloat(customWidth.value);
    const height = parseFloat(customHeight.value);
    
    let hasError = false;
    
    // Check if values are provided
    if (!customWidth.value || !customHeight.value) {
      showCustomSizeError('Please enter both width and height for custom size.');
      hasError = true;
    }
    // Check maximum size limit
    else if (width > 47 || height > 47) {
      showCustomSizeError('Maximum size is 47" x 47". Please enter smaller dimensions.');
      hasError = true;
    }
    // Check minimum size limit
    else if (width < 0.1 || height < 0.1) {
      showCustomSizeError('Minimum size is 0.1" x 0.1". Please enter larger dimensions.');
      hasError = true;
    }
    
    // Add error styling to inputs if there's an error
    if (hasError) {
      customWidth.style.borderColor = '#dc3545';
      customHeight.style.borderColor = '#dc3545';
    } else {
      customWidth.style.borderColor = '#ddd';
      customHeight.style.borderColor = '#ddd';
    }
    
    return !hasError;
  }
  
  return true;
}

// Show custom size error message
function showCustomSizeError(message) {
  const customSizeInputs = document.getElementById('customSizeInputs');
  if (customSizeInputs) {
    // Remove existing error if any
    removeCustomSizeErrors();
    
    // Create error message element
    const errorDiv = document.createElement('div');
    errorDiv.id = 'custom-size-error';
    errorDiv.style.cssText = `
      color: #dc3545;
      font-size: 14px;
      font-weight: 500;
      margin-top: 8px;
      padding: 8px 12px;
      background: #f8d7da;
      border: 1px solid #f5c6cb;
      border-radius: 4px;
      display: flex;
      align-items: center;
      gap: 8px;
    `;
    errorDiv.innerHTML = `
      <span style="color: #dc3545; font-weight: bold;">⚠️</span>
      ${message}
    `;
    
    customSizeInputs.appendChild(errorDiv);
  }
}

// Remove custom size error messages
function removeCustomSizeErrors() {
  const existingError = document.getElementById('custom-size-error');
  if (existingError) {
    existingError.remove();
  }
}










// Update material options based on label shape with forced default selection
function updateLabelMaterials() {
  const N = s => String(s || '').trim().toLowerCase();
  const shape = document.querySelector('input[name="properties[Label Shape]"]:checked')?.value || '';
  const isCS = (shape === 'Circle' || shape === 'Square');

  const csWrap = document.getElementById('label-material-circle-square');
  const orWrap = document.getElementById('label-material-oval-rectangle');

  // show/hide groups
  if (csWrap) csWrap.style.display = isCS ? 'block' : 'none';
  if (orWrap) orWrap.style.display = isCS ? 'none'  : 'block';

  // collect radios
  const all = [...document.querySelectorAll('input[name="properties[Label Material]"]')];
  const inWrap = (wrap, el) => wrap && wrap.contains(el);
  const cs = all.filter(el => inWrap(csWrap, el));
  const or = all.filter(el => inWrap(orWrap, el));

  // uncheck the hidden group so it can't leak into summary
  (isCS ? or : cs).forEach(el => { el.checked = false; });

  // try metafield only in the visible group
  const mf = N(Array.isArray(window.sfOverrides?.material) ? window.sfOverrides.material[0] : window.sfOverrides?.material);
  const visible = isCS ? cs : or;

  let chosen = null;
  if (mf) {
    chosen = visible.find(el => N(el.value) === mf);
  }

  // fallback to Matte of the visible group if metafield not available
  if (!chosen) {
    const fallbackId = isCS ? 'Matte-Laminate-Label-CS' : 'Matte-Laminate-Label-OR';
    chosen = document.getElementById(fallbackId);
    if (!chosen) chosen = visible[0]; // absolute last resort
    if (mf) console.warn(`[LABEL MAT] '${window.sfOverrides?.material}' not available for ${shape} → fallback to ${chosen?.value}`);
  }

  if (chosen) {
    chosen.checked = true;
    chosen.dispatchEvent(new Event('change', {bubbles:true}));
  }

  // keep your size-based pricing labels in sync
  if (typeof updateMaterialPricing === 'function') updateMaterialPricing();
}



// Update size options based on label shape
function updateLabelSizeOptions() {
  const shape = document.querySelector('input[name="properties[Label Shape]"]:checked')?.value;
  
  // Hide all size containers first
  const sizeContainers = [
    'circle-label-sizes',
    'square-label-sizes', 
    'oval-label-sizes',
    'rectangle-label-sizes'
  ];
  
  sizeContainers.forEach(id => {
    const container = document.getElementById(id);
    if (container) container.style.display = 'none';
  });
  
  // Show the appropriate size container
  if (shape) {
    const targetContainer = document.getElementById(`${shape.toLowerCase()}-label-sizes`);
    if (targetContainer) {
      targetContainer.style.display = 'block';
      // console.log((`Showing ${shape.toLowerCase()}-label-sizes`);
    }
  } else {
    // Default to circle if no shape selected yet
    const circleContainer = document.getElementById('circle-label-sizes');
    if (circleContainer) {
      circleContainer.style.display = 'block';
      // console.log(('Showing default circle-label-sizes');
    }
  }
}

// Update holographic/clear pricing based on size
function updateMaterialPricing() {
  const productType = document.querySelector('input[name="product-type"]:checked')?.value;
  
  if (productType === 'Custom Label') {
    const shape = document.querySelector('input[name="properties[Label Shape]"]:checked')?.value;
    
    if (shape === 'Circle' || shape === 'Square') {
      let sizeSelect;
      if (shape === 'Circle') {
        sizeSelect = document.getElementById('select-size-circle-label');
      } else {
        sizeSelect = document.getElementById('select-size-square-label');
      }
      
      if (sizeSelect && sizeSelect.value) {
        const size = parseFloat(sizeSelect.value);
        const fee = sfFeeByTier(size, sfPricingConfig?.label?.holographic_clear_fees, 'max_size');
        const price = `+$${fee.toFixed(2)}`;
        
        const holographicPrice = document.getElementById('holographic-price');
        const clearPrice = document.getElementById('clear-price');
        
        if (holographicPrice) holographicPrice.textContent = price;
        if (clearPrice) clearPrice.textContent = price;
      }
    }
  }
}

// Update price display with debugging
function updatePriceDisplay() {
  // console.log(('=== PRICE CALCULATION DEBUG ===');
  
  const dimensions = getDimensions();
  // console.log(('Dimensions:', dimensions);
  
  const qty = getQuantity();
  // console.log(('Quantity:', qty);
  
  const productType = document.querySelector('input[name="product-type"]:checked')?.value;
  // console.log(('Product Type:', productType);
  
  // DEBUG: Check material selection for stickers
  if (productType === 'Custom Sticker') {
    const material = document.querySelector('input[name="properties[Select Your Material]"]:checked')?.value;
    // console.log(('🔍 DEBUG: Sticker material selected:', material);
  }
  
  const price = calculatePrice();
  // console.log(('Calculated Price:', price);
  
  const priceDisplay = document.getElementById('price-display');
  const nextStepPriceDisplay = document.getElementById('next-step-price-display');
  const hiddenPrice = document.getElementById('hidden-price');
  
  if (priceDisplay) {
    priceDisplay.textContent = `${price.toFixed(2)}`;
    // console.log(('Updated price display to:', `${price.toFixed(2)}`);
  }
  if (nextStepPriceDisplay) nextStepPriceDisplay.textContent = `${price.toFixed(2)}`;
  if (hiddenPrice) hiddenPrice.value = price.toFixed(2);
  syncBuilderExperience();
  
  // console.log(('=== END PRICE DEBUG ===');
}

function getBuilderArtworkState() {
  const designValue = document.getElementById('designDataInput')?.value;
  const customDesignImage = window.customDesignData?.image;
  const v3DesignImage = document.querySelector('.sf-builder-v3') ? window.sfV3ArtworkData?.image : '';
  const uploadedFile = document.getElementById('file-select-quantity')?.files?.[0];
  const emailLater = document.getElementById('email-your-artwork-later')?.checked;

  if (emailLater) return { ready: true, label: 'Will send later', preview: null };
  if (customDesignImage) return { ready: true, label: 'Design created', preview: customDesignImage, source: 'customizer' };
  if (v3DesignImage) return { ready: true, label: 'Artwork ready', preview: v3DesignImage, source: 'v3' };
  if (designValue) return { ready: true, label: 'Design created', preview: designValue };
  if (uploadedFile) return { ready: true, label: 'File uploaded', preview: uploadedFile };
  return { ready: false, label: 'Not yet added', preview: null };
}

function getSfCurrentProductPreviewShape() {
  const selectedShape = getSfVisibleCheckedValue('input[name="properties[Select Your Shape]"]') ||
    getSfVisibleCheckedValue('input[name="properties[Label Shape]"]') ||
    'Original';

  return ['Circle', 'Square', 'Oval', 'Rectangle'].includes(selectedShape) ? selectedShape : 'Original';
}

function getSfSelectedPreviewShape() {
  return getSfCurrentProductPreviewShape();
}

function setSfArtworkPreviewShape(shape) {
  window.sfArtworkPreviewShape = getSfCurrentProductPreviewShape();
  syncBuilderExperience();
}

function getSfMaskClass(shape) {
  const normalized = String(shape || 'Original').toLowerCase();
  return ['circle', 'square', 'oval', 'rectangle'].includes(normalized) ? `is-${normalized}` : 'is-original';
}

function createSfArtworkImage(src, alt, shape) {
  const frame = document.createElement('div');
  frame.className = `sf-preview-artwork-frame ${getSfMaskClass(shape)}`;

  const image = document.createElement('img');
  image.src = src;
  image.alt = alt;
  image.className = 'sf-preview-artwork-image';

  frame.appendChild(image);
  return frame;
}

function renderSfArtworkMaskControls(previewElement, activeShape, enabled) {
  const parent = previewElement?.parentElement;
  parent?.querySelector('.sf-preview-mask-controls')?.remove();
}

function loadSfImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const url = URL.createObjectURL(file);
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Unable to load uploaded artwork for preview.'));
    };
    image.src = url;
  });
}

async function createSfMaskedArtworkFile(file, shape) {
  if (!(file instanceof File) || !file.type.startsWith('image/')) return null;

  const normalizedShape = ['Circle', 'Square', 'Oval', 'Rectangle'].includes(shape) ? shape : 'Original';
  const image = await loadSfImageFromFile(file);
  const canvas = document.createElement('canvas');
  const canvasSize = {
    Original: { width: image.naturalWidth, height: image.naturalHeight },
    Circle: { width: 1200, height: 1200 },
    Square: { width: 1200, height: 1200 },
    Oval: { width: 1400, height: 900 },
    Rectangle: { width: 1600, height: 900 }
  }[normalizedShape] || { width: 1200, height: 1200 };
  canvas.width = canvasSize.width;
  canvas.height = canvasSize.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  const width = canvas.width;
  const height = canvas.height;
  ctx.clearRect(0, 0, width, height);
  ctx.save();

  if (normalizedShape === 'Circle') {
    ctx.beginPath();
    ctx.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, Math.PI * 2);
    ctx.clip();
  } else if (normalizedShape === 'Oval') {
    ctx.beginPath();
    ctx.ellipse(width / 2, height / 2, width / 2, height / 2, 0, 0, Math.PI * 2);
    ctx.clip();
  } else if (normalizedShape === 'Rectangle') {
    ctx.beginPath();
    ctx.rect(0, 0, width, height);
    ctx.clip();
  }

  const scale = normalizedShape === 'Original'
    ? 1
    : Math.max(width / image.naturalWidth, height / image.naturalHeight);
  const drawWidth = image.naturalWidth * scale;
  const drawHeight = image.naturalHeight * scale;
  ctx.drawImage(image, (width - drawWidth) / 2, (height - drawHeight) / 2, drawWidth, drawHeight);
  ctx.restore();

  const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png', 0.92));
  if (!blob) return null;

  const safeName = (file.name || 'artwork').replace(/\.[^.]+$/, '').replace(/[^a-z0-9_-]+/gi, '-').replace(/^-+|-+$/g, '') || 'artwork';
  return new File([blob], `${safeName}-${normalizedShape.toLowerCase()}-preview.png`, { type: 'image/png' });
}

function createSfFileFromDataUrl(dataUrl, name = 'custom-design.png') {
  if (typeof dataUrl !== 'string' || !dataUrl.startsWith('data:image/')) return null;

  const parts = dataUrl.split(',');
  if (parts.length < 2) return null;

  const match = parts[0].match(/^data:([^;]+);base64$/i);
  if (!match) return null;

  const binary = atob(parts[1]);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new File([bytes], name, { type: match[1] || 'image/png' });
}

async function createSfMaskedArtworkFileFromDataUrl(dataUrl, shape) {
  const sourceFile = createSfFileFromDataUrl(dataUrl, 'custom-design.png');
  if (!sourceFile) return null;
  return createSfMaskedArtworkFile(sourceFile, shape);
}

async function appendSfArtworkFiles(formData, options = {}) {
  const fileInput = document.getElementById('file-select-quantity');
  const file = fileInput?.files?.[0];
  const emailLater = document.getElementById('email-your-artwork-later')?.checked;
  if (emailLater) return;
  if (!file) return;

  formData.set('artwork_file', file);
  const shape = getSfCurrentProductPreviewShape();
  formData.set('Artwork_Preview_Shape', shape);
  const maskedFile = await createSfMaskedArtworkFile(file, shape);
  if (maskedFile) formData.set('masked_artwork_file', maskedFile);
}

async function appendSfCustomDesignData(formData) {
  const emailLater = document.getElementById('email-your-artwork-later')?.checked;
  if (emailLater) return false;

  const isV3Builder = Boolean(document.querySelector('.sf-builder-v3'));
  let designData = window.customDesignData || (isV3Builder ? window.sfV3ArtworkData : null);
  if (isV3Builder && window.sfV3ArtworkData && typeof window.sfPrepareV3ArtworkData === 'function') {
    designData = window.sfPrepareV3ArtworkData();
  }
  if (!designData?.image) return false;

  const shape = getSfCurrentProductPreviewShape();
  designData = Object.assign({}, designData, { shape });
  formData.append('custom_design_data', JSON.stringify(designData));
  formData.append('design_image_url', designData.image);
  formData.append('is_custom_design', 'true');
  formData.set('Artwork_Preview_Shape', shape);

  const maskedFile = await createSfMaskedArtworkFileFromDataUrl(designData.image, shape);
  if (maskedFile) formData.set('masked_artwork_file', maskedFile);

  return true;
}

function getBuilderSummaryValue(selector, fallback = '') {
  return document.querySelector(selector)?.value || fallback;
}

function syncLockedBuilderOfferMode() {
  const builder = document.querySelector('.sf-builder-page');
  if (!builder) return false;

  const locked = isSfLockedBuilderOffer();
  builder.classList.toggle('sf-builder-locked-offer', locked);
  if (!locked) return false;

  document.querySelectorAll('[data-builder-slot="type"] input, [data-builder-slot="shape"] input, [data-builder-slot="size-quantity"] input, [data-builder-slot="size-quantity"] select, [data-builder-slot="finish"] input, [data-builder-slot="finish"] select').forEach(control => {
    control.disabled = true;
    control.setAttribute('aria-disabled', 'true');
  });

  document.querySelectorAll('.sf-flow-step[data-builder-step="1"], .sf-flow-step[data-builder-step="2"], .sf-flow-step[data-builder-step="3"]').forEach(step => {
    step.classList.add('is-complete', 'sf-offer-locked-step');
    step.classList.remove('is-active', 'needs-attention');
  });

  const artworkStep = document.querySelector('.sf-flow-step[data-builder-step="4"]');
  if (artworkStep) {
    artworkStep.classList.add('is-active');
    artworkStep.classList.remove('is-complete');
  }

  const progressTitle = document.getElementById('sf-progress-title');
  if (progressTitle) progressTitle.textContent = 'Add artwork to complete this special offer';
  const progressFill = document.getElementById('sf-progress-fill');
  if (progressFill) progressFill.style.width = '100%';

  window.sfCurrentBuilderStep = 4;
  return true;
}

function syncBuilderExperience() {
  if (!document.querySelector('.sf-builder-page')) return;

  ensureBuilderSubmitButton();

  const productType = document.querySelector('input[name="product-type"]:checked')?.value || 'Custom Sticker';
  const stickerMode = productType === 'Custom Sticker';
  const shape = stickerMode
    ? document.querySelector('input[name="properties[Select Your Shape]"]:checked')?.value
    : document.querySelector('input[name="properties[Label Shape]"]:checked')?.value;
  const material = stickerMode
    ? document.querySelector('input[name="properties[Select Your Material]"]:checked')?.value
    : document.querySelector('input[name="properties[Label Material]"]:checked')?.value;
  const enhancement = document.querySelector('input[name="properties[Enhance Image Quality]"]:checked')?.value;
  const qty = stickerMode
    ? getBuilderSummaryValue('#sticker-quantity', '50')
    : getBuilderSummaryValue('#label-quantity', '50');
  const dimensions = getDimensions();
  const artwork = getBuilderArtworkState();
  const price = calculatePrice();

  document.querySelectorAll('.sf-sticker-only').forEach(card => {
    card.hidden = !stickerMode;
  });
  document.querySelectorAll('.sf-label-only').forEach(card => {
    card.hidden = stickerMode;
  });

  let size = '';
  if (stickerMode) {
    size = getBuilderSummaryValue('#select-size-sticker', '3 x 3');
    if (size === 'Custom Size' && dimensions) size = `${dimensions.width}" x ${dimensions.height}"`;
  } else if (shape === 'Circle') {
    size = `${getBuilderSummaryValue('#select-size-circle-label', '2')}"`;
  } else if (shape === 'Square') {
    size = `${getBuilderSummaryValue('#select-size-square-label', '2')}"`;
  } else if (shape === 'Oval') {
    size = getBuilderSummaryValue('#select-size-oval-label', '3x2').replace('x', '" x ') + '"';
  } else if (shape === 'Rectangle') {
    size = getBuilderSummaryValue('#select-size-rectangle-label', '2.75x1').replace('x', '" x ') + '"';
  }

  const setText = (id, value) => {
    const element = document.getElementById(id);
    if (element) element.textContent = value || '-';
  };
  const builderHeading = document.getElementById('sf-builder-heading');
  if (builderHeading) {
    const headingShape = String(shape || 'Custom')
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
    builderHeading.textContent = `Premium Custom ${headingShape} ${stickerMode ? 'Stickers' : 'Labels'}`;
  }
  const builderDescription = document.getElementById('sf-builder-description');
  if (builderDescription) {
    builderDescription.textContent = stickerMode
      ? 'Custom die-cut stickers printed on thick, durable waterproof vinyl with a gloss or matte laminate finish. Scratch-resistant, UV-resistant, and weatherproof. Perfect for businesses, branding, packaging, cars, laptops, thermal mugs and events.'
      : 'Custom labels on a roll printed on thick, durable water resistant BOPP with an option of gloss or matte laminate finish. Scratch-resistant, Oil-resistant, and dishwasher safe. Perfect for branding products, labeling, plastic cups, bottles and events.';
  }
  const builderSubheading = document.getElementById('sf-builder-subheading');
  if (builderSubheading) {
    builderSubheading.innerHTML = '<span>Instant pricing, easy checkout, and 24 to 48 hour delivery option available.</span><span class="sf-builder-printed-count"><strong>30,252,450+</strong> stickers/labels printed by our team!</span>';
  }

  setText('sf-summary-type', productType);
  setText('sf-summary-shape', `${shape || 'Custom'} ${stickerMode ? 'Sticker' : 'Label'}`);
  setText('sf-summary-size', size);
  setText('sf-summary-material', material);
  setText('sf-summary-enhance', enhancement);
  setText('sf-summary-quantity', `${qty} pcs`);
  setText('sf-summary-artwork', artwork.label);
  setText('sf-summary-price', `$${price.toFixed(2)}`);
  setText('sf-summary-mobile-brief', `${shape || 'Custom shape'} - ${size || 'Custom size'} - ${qty} pcs`);

  const status = document.getElementById('sf-summary-status');
  if (status) {
    status.textContent = artwork.ready ? 'Ready to submit order.' : 'Choose artwork before checkout.';
    status.classList.toggle('is-ready', artwork.ready);
  }

  const submitButton = document.getElementById('add-to-cart-btn');
  const stepSubmitButton = document.getElementById('sf-step-submit-btn');
  if (submitButton) {
    submitButton.disabled = !artwork.ready;
    submitButton.textContent = 'Checkout';
  }
  if (stepSubmitButton) {
    stepSubmitButton.disabled = !artwork.ready;
    stepSubmitButton.textContent = 'Checkout';
  }

  const preview = document.getElementById('sf-design-preview');
  if (preview && !(document.querySelector('.sf-builder-v3') && artwork.source === 'v3')) {
    renderSfArtworkMaskControls(preview, 'Original', false);
    preview.innerHTML = '';
    if (artwork.preview instanceof File && artwork.preview.type.startsWith('image/')) {
      preview.appendChild(createSfArtworkImage(URL.createObjectURL(artwork.preview), 'Uploaded artwork preview', 'Original'));
    } else if (artwork.preview && typeof artwork.preview === 'string') {
      preview.appendChild(createSfArtworkImage(artwork.preview, 'Created artwork preview', 'Original'));
    } else {
      const text = document.createElement('span');
      text.textContent = artwork.ready ? 'Artwork will be emailed later' : 'Upload artwork to preview';
      preview.appendChild(text);
    }
  }

  const checks = [
    { key: 'type', done: Boolean(productType) },
    { key: 'shape', done: Boolean(shape) },
    { key: 'size', done: Boolean(size && dimensions && qty) },
    { key: 'finish', done: Boolean(material && enhancement) },
    { key: 'artwork', done: artwork.ready }
  ];
  const firstIncomplete = checks.find(step => !step.done)?.key || null;
  const activeStepNumber = Number(window.sfCurrentBuilderStep || document.querySelector('.sf-flow-step.is-active')?.dataset.builderStep || 0);
  const visibleSteps = [
    { key: 'type', done: checks[0].done },
    { key: 'shape', done: checks[1].done },
    { key: 'size', done: checks[2].done },
    { key: 'details', done: checks[3].done && checks[4].done }
  ];
  const visualProgress = Math.min(Math.max(activeStepNumber || 1, 1), visibleSteps.length);
  const fill = document.getElementById('sf-progress-fill');
  if (fill) fill.style.width = `${(visualProgress / visibleSteps.length) * 100}%`;
  const progressTitles = {
    1: 'Choose your product type',
    2: 'Choose your shape',
    3: 'Set your size & quantity',
    4: artwork.ready ? 'Ready to submit your order' : 'Add your design to finish'
  };
  setText('sf-progress-title', progressTitles[activeStepNumber] || progressTitles[4]);

  document.querySelectorAll('.sf-flow-step').forEach(stepElement => {
    const number = Number(stepElement.dataset.builderStep);
    const needsAttention =
      (number === 1 && firstIncomplete === 'type') ||
      (number === 2 && firstIncomplete === 'shape') ||
      (number === 3 && firstIncomplete === 'size') ||
      (number === 4 && ['finish', 'artwork'].includes(firstIncomplete));
    stepElement.classList.toggle('needs-attention', needsAttention);
  });

  setText('sf-step-summary-type', `${productType} selected`);
  setText('sf-step-summary-shape', shape ? `${shape} selected` : 'Choose your shape');
  setText('sf-step-summary-size', size ? `${size}, ${qty} pcs` : 'Set your size and quantity');
  setText('sf-step-summary-finish', material ? material : 'Choose finish and upgrades');
  setText('sf-step-summary-artwork', artwork.ready ? artwork.label : 'Upload, create, or email later');

  syncLockedBuilderOfferMode();
}

function ensureBuilderSubmitButton() {
  const submitButtons = [...document.querySelectorAll('#add-to-cart-btn')];
  const summarySubmitSlot = document.getElementById('sf-summary-submit-slot');
  const existingSummaryButton = summarySubmitSlot?.querySelector('#add-to-cart-btn');
  const submitButton = existingSummaryButton || submitButtons[submitButtons.length - 1];

  submitButtons.forEach(button => {
    if (button !== submitButton) button.remove();
  });

  if (submitButton && summarySubmitSlot && submitButton.parentElement !== summarySubmitSlot) {
    submitButton.setAttribute('form', 'product-form');
    summarySubmitSlot.appendChild(submitButton);
  }

  if (submitButton) submitButton.textContent = 'Checkout';
}

function bindBuilderProgressNavigation() {
  if (!document.querySelector('.sf-builder-page')) return;
}

function bindBuilderMobileSummary() {
  const card = document.querySelector('.sf-order-card');
  const toggle = document.querySelector('.sf-summary-mobile-toggle');
  if (!card || !toggle || toggle.dataset.bound === 'true') return;

  const setExpanded = expanded => {
    card.classList.toggle('is-expanded', expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.setAttribute('aria-label', expanded ? 'Hide order summary' : 'Show order summary');
  };

  toggle.dataset.bound = 'true';
  toggle.addEventListener('click', event => {
    event.preventDefault();
    setExpanded(!card.classList.contains('is-expanded'));
  });
}

function moveBuilderNode(nodeOrSelector, slotName) {
  const node = typeof nodeOrSelector === 'string' ? document.querySelector(nodeOrSelector) : nodeOrSelector;
  const slot = document.querySelector(`[data-builder-slot="${slotName}"]`);
  if (node && slot) slot.appendChild(node);
}

function setBuilderStep(stepNumber, shouldScroll = true) {
  if (isSfLockedBuilderOffer() && Number(stepNumber) < 4) {
    stepNumber = 4;
    shouldScroll = false;
  }

  window.sfCurrentBuilderStep = stepNumber;

  document.querySelectorAll('.sf-flow-step').forEach(step => {
    const number = Number(step.dataset.builderStep);
    step.classList.toggle('is-active', number === stepNumber);
    step.classList.toggle('is-complete', number < stepNumber);
  });

  if (typeof updateBuilderSummary === 'function') updateBuilderSummary();
  renderBuilderProgressState();

  if (shouldScroll) {
    scrollBuilderStepIntoView(stepNumber);
  }
}

function renderBuilderProgressState() {
  syncBuilderExperience();
}

function scrollBuilderStepIntoView(stepNumber) {
  const step = document.querySelector(`.sf-flow-step[data-builder-step="${stepNumber}"]`);
  if (!step) return;

  window.requestAnimationFrame(() => {
    const isMobile = window.matchMedia?.('(max-width: 749px)').matches;
    const progress = document.querySelector('.sf-builder-progress');
    const offset = (progress?.getBoundingClientRect().height || 0) + 26;
    const rect = step.getBoundingClientRect();

    if (isMobile) {
      const top = rect.top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      return;
    }

    const comfortableTop = Math.min(window.innerHeight * 0.34, 260);
    const desiredScroll = rect.top + window.scrollY - comfortableTop;
    const maxGentleMove = 220;
    const nextScroll = Math.max(
      0,
      Math.min(desiredScroll, window.scrollY + maxGentleMove)
    );

    if (Math.abs(nextScroll - window.scrollY) > 12) {
      window.scrollTo({ top: nextScroll, behavior: 'smooth' });
    }
  });
}

function setupDedicatedBuilderFlow() {
  if (!document.querySelector('.sf-builder-page')) return;

  const typeCard = document.querySelector('#step-1-section > form > .step-card:first-child');
  const stickerCards = [...document.querySelectorAll('#custom-sticker-options > .step-card')];
  const labelCards = [...document.querySelectorAll('#custom-label-options > .step-card')];
  const enhancementCard = document.querySelector('#enhance-btn')?.closest('.step-card');
  const quantityCard = document.getElementById('sticker-quantity-container')?.closest('.step-card');
  const designSection = document.getElementById('next-step-section');
  const submitButton = document.getElementById('add-to-cart-btn');
  const summarySubmitSlot = document.getElementById('sf-summary-submit-slot');

  stickerCards.forEach(card => card.classList.add('sf-sticker-only'));
  labelCards.forEach(card => card.classList.add('sf-label-only'));

  moveBuilderNode(typeCard, 'type');
  moveBuilderNode(stickerCards[0], 'shape');
  moveBuilderNode(labelCards[0], 'shape');
  moveBuilderNode(stickerCards[1], 'size-quantity');
  moveBuilderNode(labelCards[1], 'size-quantity');
  moveBuilderNode(quantityCard, 'size-quantity');
  moveBuilderNode(stickerCards[2], 'finish');
  stickerCards[3]?.remove();
  moveBuilderNode(labelCards[2], 'finish');
  moveBuilderNode(enhancementCard, 'finish');
  moveBuilderNode(designSection, 'design');

  stickerCards[2]?.classList.add('sf-builder-material-card');
  labelCards[2]?.classList.add('sf-builder-material-card');
  enhancementCard?.classList.add('sf-builder-enhance-card');

  if (submitButton && summarySubmitSlot) {
    submitButton.setAttribute('form', 'product-form');
    summarySubmitSlot.appendChild(submitButton);
  }

  if (designSection) {
    designSection.style.display = 'block';
    const legacyUploadBox = designSection.querySelector('.sf-upload-artwork-box, div[style*="border: 5px"], div[style*="#1EB0E4"]');
    if (legacyUploadBox) {
      legacyUploadBox.style.border = '0';
      legacyUploadBox.style.background = '#fff';
      legacyUploadBox.style.padding = '18px 0 0';
      legacyUploadBox.style.marginTop = '0';
    }
  }

  [stickerCards[1], labelCards[1]].forEach(card => card?.classList.add('sf-builder-size-card'));
  quantityCard?.classList.add('sf-builder-quantity-card');

  document.querySelectorAll('.sf-flow-step-header').forEach(button => {
    button.addEventListener('click', () => {
      setBuilderStep(Number(button.closest('.sf-flow-step')?.dataset.builderStep || 1));
    });
  });

  document.querySelectorAll('[data-builder-next]').forEach(button => {
    button.addEventListener('click', () => {
      setBuilderStep(Number(button.dataset.builderNext));
    });
  });

  bindBuilderMobileSummary();

  document.getElementById('sf-use-tool-btn')?.addEventListener('click', event => {
    event.preventDefault();
    if (typeof openStickerFreaksCustomizer === 'function') {
      openStickerFreaksCustomizer();
    } else if (typeof editCustomDesign === 'function') {
      editCustomDesign();
    } else {
      document.getElementById('upload-design-btn')?.click();
    }
  });
  document.getElementById('sf-upload-file-btn')?.addEventListener('click', () => {
    document.getElementById('file-select-quantity')?.click();
  });

  document.getElementById('sf-step-submit-btn')?.addEventListener('click', () => {
    document.getElementById('add-to-cart-btn')?.click();
  });

  document.addEventListener('click', event => {
    const launchButton = event.target.closest?.('#launchCustomizerBtn');
    if (!launchButton) return;
    event.preventDefault();
    openStickerFreaksCustomizer();
  });

  setBuilderStep(isSfLockedBuilderOffer() ? 4 : 2, false);
  syncLockedBuilderOfferMode();
}

function updateProductTypeBanner(productType) {
  const banner = document.querySelector('.sf-builder-banner');
  if (!banner) return;

  const bannerUrl = productType === 'Custom Label'
    ? banner.dataset.labelBanner
    : banner.dataset.stickerBanner;

  if (bannerUrl) {
    banner.style.backgroundImage = `url('${bannerUrl}')`;
  }
}

function redirectToProductTypePage(productType, event) {
  if (!event?.isTrusted) return false;

  const targetPath = productType === 'Custom Label'
    ? '/products/custom-labels'
    : '/products/custom-stickers';
  const targetUrl = new URL(targetPath, window.location.origin);
  const currentParams = new URLSearchParams(window.location.search);
  const view = currentParams.get('view');
  if (view) targetUrl.searchParams.set('view', view);

  if (window.location.pathname.replace(/\/$/, '') === targetPath) return false;

  window.location.href = targetUrl.toString();
  return true;
}

function getSfProductTypeFromPath() {
  const path = window.location.pathname.replace(/\/$/, '').toLowerCase();
  if (path === '/products/custom-labels') return 'Custom Label';
  if (path === '/products/custom-stickers') return 'Custom Sticker';
  return '';
}

function bindProductTypeRedirectClicks() {
  if (window.sfProductTypeRedirectClicksBound) return;
  window.sfProductTypeRedirectClicksBound = true;

  document.addEventListener('click', function(event) {
    if (!event.isTrusted) return;

    const target = event.target.closest?.('#custom-sticker, #custom-label, label[for="custom-sticker"], label[for="custom-label"]');
    if (!target) return;

    const productType = (target.id === 'custom-label' || target.getAttribute('for') === 'custom-label')
      ? 'Custom Label'
      : 'Custom Sticker';

    const targetPath = productType === 'Custom Label'
      ? '/products/custom-labels'
      : '/products/custom-stickers';
    const targetUrl = new URL(targetPath, window.location.origin);
    const currentParams = new URLSearchParams(window.location.search);
    const view = currentParams.get('view');
    if (view) targetUrl.searchParams.set('view', view);

    if (window.location.pathname.replace(/\/$/, '') === targetPath) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = targetUrl.toString();
  }, true);
}

// Toggle between product types with enhanced material default selection
function toggleProductType() {
  const hiddenProductType = document.getElementById('hidden-product-type');
  const customSticker = document.getElementById('custom-sticker');
  const customLabel = document.getElementById('custom-label');
  const stickerOptions = document.getElementById('custom-sticker-options');
  const labelOptions = document.getElementById('custom-label-options');
  const stickerQuantity = document.getElementById('sticker-quantity-container');
  const labelQuantity = document.getElementById('label-quantity-container');
  const customSizeInputs = document.getElementById('customSizeInputs');

  if (customSticker && customSticker.checked) {


    if (hiddenProductType) hiddenProductType.value = 'Custom Sticker';
    updateProductTypeBanner('Custom Sticker');
    if (stickerOptions) stickerOptions.style.display = 'block';
    if (labelOptions) labelOptions.style.display = 'none';
    if (stickerQuantity) stickerQuantity.style.display = 'block';
    if (labelQuantity) labelQuantity.style.display = 'none';
    if (customSizeInputs) customSizeInputs.style.display = 'none';

    // Clear and disable label inputs
    const labelInputs = document.querySelectorAll('input[name*="Label"], select[name*="Label"]');
    labelInputs.forEach(input => {
      if (input.type === 'radio' || input.type === 'checkbox') {
        input.checked = false;
      } else {
        input.value = '';
      }
      input.disabled = true;
    });

    // Re-enable sticker inputs
    const shapeInputs = document.querySelectorAll('input[name="properties[Select Your Shape]"]');
    shapeInputs.forEach(input => {
      input.disabled = false;
    });
    
    // Restore sticker defaults
// OLD
const diecut = document.getElementById('Die-cut');
if (!window.sfOverridesApplied && diecut && !document.querySelector('input[name="properties[Select Your Shape]"]:checked')) {
  diecut.checked = true;
}

const stickerQtySelect = document.getElementById('sticker-quantity');
if (!hasSfSizeQtyOverrides() && stickerQtySelect) stickerQtySelect.value = '50';


    
  } else if (customLabel && customLabel.checked) {


    if (hiddenProductType) hiddenProductType.value = 'Custom Label';
    updateProductTypeBanner('Custom Label');
    if (stickerOptions) stickerOptions.style.display = 'none';
    if (labelOptions) labelOptions.style.display = 'block';
    if (stickerQuantity) stickerQuantity.style.display = 'none';
    if (labelQuantity) labelQuantity.style.display = 'block';
    if (customSizeInputs) customSizeInputs.style.display = 'none';

    // Enable label inputs
    const labelInputs = document.querySelectorAll('input[name*="Label"], select[name*="Label"]');
    labelInputs.forEach(input => {
      input.disabled = false;
    });
  
    // Disable sticker inputs
    const shapeInputs = document.querySelectorAll('input[name="properties[Select Your Shape]"]');
    shapeInputs.forEach(input => {
      input.disabled = true;
      input.checked = false;
    });

// Restore label defaults
const circleLabel = document.getElementById('Circle-Label');
if (circleLabel) circleLabel.checked = true;

const labelQtySelect = document.getElementById('label-quantity');
if (!hasSfSizeQtyOverrides() && labelQtySelect) labelQtySelect.value = '50';

setTimeout(() => {
  updateLabelSizeOptions();
  updateLabelMaterials();
  updateMaterialPricing();
  
 // RESTORE default sizes for ALL label shapes
if (!hasSfSizeQtyOverrides()) {
  const circleSize = document.getElementById('select-size-circle-label');
  if (circleSize) circleSize.value = '2';
  
  const squareSize = document.getElementById('select-size-square-label');
  if (squareSize) squareSize.value = '2';
  
  const ovalSize = document.getElementById('select-size-oval-label');
  if (ovalSize) ovalSize.value = '3x2';
  
  const rectangleSize = document.getElementById('select-size-rectangle-label');
  if (rectangleSize) rectangleSize.value = '2.75x1';
}
  
  const onSheetLabel = document.getElementById('On-Sheet-Label');
  if (onSheetLabel) onSheetLabel.checked = true;
}, 10);


  }
  
  setTimeout(() => {
    updatePriceDisplay();
  }, 50);
}

// Handle custom size inputs for stickers - ENHANCED WITH CLEAR RESET
function handleCustomSize() {
  const sizeSelect = document.getElementById('select-size-sticker');
  const customWidth = document.getElementById('custom-width-input');
  const customHeight = document.getElementById('custom-height-input');
  const customSizeInputs = document.getElementById('customSizeInputs');
  
  if (sizeSelect && sizeSelect.value === 'Custom Size') {
    if (customSizeInputs) customSizeInputs.style.display = 'block';
    if (customWidth) customWidth.style.display = 'inline-block';
    if (customHeight) customHeight.style.display = 'inline-block';
    
    // Validate when switching to custom size
    setTimeout(() => {
      validateCustomSize();
    }, 10);
  } else {
    if (customSizeInputs) customSizeInputs.style.display = 'none';
    // FIXED: Clear custom inputs when switching away from custom size
    if (customWidth) {
      customWidth.style.display = 'none';
      customWidth.value = ''; // Clear the value
      customWidth.style.borderColor = '#ddd'; // Reset border color
    }
    if (customHeight) {
      customHeight.style.display = 'none';
      customHeight.value = ''; // Clear the value
      customHeight.style.borderColor = '#ddd'; // Reset border color
    }
    
    // Remove errors when switching away from custom size
    removeCustomSizeErrors();
    
    // FIXED: Force immediate price update when switching to preset size
    // console.log(('🔄 Switching from custom to preset size, updating price...');
    setTimeout(() => {
      updatePriceDisplay();
    }, 10);
  }
}

// Update step 2 display - FIXED VERSION
function updateStep2Display() {
        const productType = document.querySelector('input[name="product-type"]:checked')?.value;
  
  // Update product type
const productTypeElement = document.getElementById('selected-product-type');
if (productTypeElement) {
  productTypeElement.textContent = productType || '';
}
 
  
  // Update shape
  let selectedShape = '';
  if (productType === 'Custom Sticker') {
    selectedShape = document.querySelector('input[name="properties[Select Your Shape]"]:checked')?.value || '';
  } else if (productType === 'Custom Label') {
    selectedShape = document.querySelector('input[name="properties[Label Shape]"]:checked')?.value || '';
  }
  
  // Update size
  const dimensions = getDimensions();
  let selectedSize = '';
  if (dimensions) {
    if (productType === 'Custom Label') {
      selectedSize = dimensions.sizeKey || '';
      if (dimensions.shape === 'Circle' || dimensions.shape === 'Square') {
        selectedSize += '"';
      }
    } else {
      selectedSize = `${dimensions.width}" x ${dimensions.height}"`;
    }
  }
  
  // Update material - check both sticker and label material selectors
  let selectedMaterial = '';
  if (productType === 'Custom Sticker') {
    selectedMaterial = document.querySelector('input[name="properties[Select Your Material]"]:checked')?.value || '';
  } else if (productType === 'Custom Label') {
selectedMaterial = ([...document.querySelectorAll('input[name="properties[Label Material]"]:checked')]
  .find(el => el.offsetParent !== null)?.value) || '';

  }
  
  // Update quantity
  const qty = getQuantity();
  const selectedQuantity = qty ? `${qty} pcs` : '';
  
  // Update DOM elements
  const shapeElement = document.getElementById('selected-shape');
  const sizeElement = document.getElementById('selected-size');
  const materialElement = document.getElementById('selected-material');
  const quantityElement = document.getElementById('selected-quantity');
  
  if (shapeElement) shapeElement.textContent = selectedShape;
  if (sizeElement) sizeElement.textContent = selectedSize;
  if (materialElement) materialElement.textContent = selectedMaterial;
  if (quantityElement) quantityElement.textContent = selectedQuantity;
  
  // Show/hide containers based on product type and selections
  const shapeContainer = document.getElementById('shape-container');
  const sizeContainer = document.getElementById('size-container');
  const materialContainer = document.getElementById('material-container');
  const quantityContainer = document.getElementById('quantity-container');
  
  if (shapeContainer) shapeContainer.style.display = selectedShape ? 'flex' : 'none';
  if (sizeContainer) sizeContainer.style.display = selectedSize ? 'flex' : 'none';
  if (materialContainer) materialContainer.style.display = selectedMaterial ? 'flex' : 'none';
  if (quantityContainer) quantityContainer.style.display = selectedQuantity ? 'flex' : 'none';
}

// Handle step navigation - ENHANCED WITH VALIDATION
function handleStepNavigation() {
  const uploadDesignBtn = document.getElementById('upload-design-btn');
  const backToEditorBtn = document.getElementById('back-to-editor');
  const step1Section = document.getElementById('step-1-section');
  const nextStepSection = document.getElementById('next-step-section');
  
  if (uploadDesignBtn) {
    uploadDesignBtn.addEventListener('click', function(e) {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
      const price = calculatePrice();
      const productType = document.querySelector('input[name="product-type"]:checked')?.value;
      
      // Validation based on product type
      let isValid = true;
            const dealModeOn = sfTruthyValue(window.sfOverrides?.dealMode) || sfTruthyValue(readMetafieldOverrides()?.dealMode);

      let validationMessage = '';
      
        if (dealModeOn) {
          // In deal mode, skip table/size/qty presence checks; still require product type and material.
          const productTypeNow = document.querySelector('input[name="product-type"]:checked')?.value;
          const materialChosen = document.querySelector('input[name="properties[Select Your Material]"]:checked') ||
                                 document.querySelector('input[name="properties[Label Material]"]:checked');

          if (!productTypeNow) { isValid = false; validationMessage = 'Please select a product type.'; }
          else if (!materialChosen) { isValid = false; validationMessage = 'Please select a material.'; }
          else { isValid = true; validationMessage = ''; }

          // Jump past the normal validation path
          if (isValid) {
  if (step1Section) step1Section.style.display = 'none';
  if (nextStepSection) nextStepSection.style.display = 'block';
  window.scrollTo({ top: 80, behavior: 'smooth' });
  return; // ✅ stop here so normal validation doesn’t run
}

        }


      if (!productType) {
        isValid = false;
        validationMessage = 'Please select a product type.';
      } else if (price <= 0) {
        // Enhanced validation for custom size
        const sizeSelect = document.getElementById('select-size-sticker');
        if (sizeSelect && sizeSelect.value === 'Custom Size') {
          const customWidth = document.getElementById('custom-width-input');
          const customHeight = document.getElementById('custom-height-input');
          const width = parseFloat(customWidth.value);
          const height = parseFloat(customHeight.value);
          
          if (!customWidth.value || !customHeight.value) {
            isValid = false;
            validationMessage = 'Please enter both width and height for custom size.';
          } else if (width > 47 || height > 47) {
            isValid = false;
            validationMessage = 'Maximum size is 47" x 47". Please enter smaller dimensions.';
          } else if (width < 0.1 || height < 0.1) {
            isValid = false;
            validationMessage = 'Minimum size is 0.1" x 0.1". Please enter larger dimensions.';
          } else {
            isValid = false;
            validationMessage = 'Please complete all required selections.';
          }
        } else {
          isValid = false;
          validationMessage = 'Please complete all required selections.';
        }
      } else {
        // Check if required fields are selected
        const dimensions = getDimensions();
        const qty = getQuantity();
        const material = document.querySelector('input[name="properties[Select Your Material]"]:checked');
        
        if (!dimensions) {
          isValid = false;
          validationMessage = 'Please select a size.';
        } else if (!qty) {
          isValid = false;
          validationMessage = 'Please select a quantity.';
        } else if (!material) {
          isValid = false;
          validationMessage = 'Please select a material.';
        }
        
        // Additional validation for stickers
        if (productType === 'Custom Sticker') {
          const shape = document.querySelector('input[name="properties[Select Your Shape]"]:checked');
          
          if (!shape) {
            isValid = false;
            validationMessage = 'Please select a shape.';
          }
          
          // Additional custom size validation
          const sizeSelect = document.getElementById('select-size-sticker');
          if (sizeSelect && sizeSelect.value === 'Custom Size') {
            if (!validateCustomSize()) {
              isValid = false;
              validationMessage = 'Please fix the custom size errors before continuing.';
            }
          }
        }
        
        // Additional validation for labels
        if (productType === 'Custom Label') {
          const labelShape = document.querySelector('input[name="properties[Label Shape]"]:checked');
          const labelMaterial = document.querySelector('input[name="properties[Label Material]"]:checked');
          
          if (!labelShape) {
            isValid = false;
            validationMessage = 'Please select a label shape.';
          } else if (!labelMaterial) {
            isValid = false;
            validationMessage = 'Please select a label material.';
          }
        }
      }
      
      if (isValid) {
        updateStep2Display();
        if (step1Section) step1Section.style.display = 'none';
        if (nextStepSection) nextStepSection.style.display = 'block';

        window.scrollTo({ top: 80, behavior: 'smooth' });





        
      } else {
        // Enhanced error display
        showValidationError(validationMessage);
      }
           return false;
    });
  }
  
  if (backToEditorBtn) {
    backToEditorBtn.addEventListener('click', function() {
      if (step1Section) step1Section.style.display = 'block';
      if (nextStepSection) nextStepSection.style.display = 'none';



 


      
    });
  }
}





function validateFileForMobile(file) {
  const maxSize = 10 * 1024 * 1024;
  const validExtensions = ['.ai', '.eps', '.jpg', '.jpeg', '.png', '.pdf', '.tiff', '.tif', '.svg'];
  const fileName = file.name.toLowerCase();
  const hasValidExtension = validExtensions.some(ext => fileName.endsWith(ext));

  if (file.size > maxSize) {
    return false;
  }
  
  // Mobile browsers sometimes don't set MIME type correctly
  const hasValidMimeType = file.type.startsWith('image/') || 
                          file.type === 'application/pdf' ||
                          file.type === '' || 
                          file.type === 'application/octet-stream';
  
  return hasValidExtension && hasValidMimeType;
}

// Show validation error with better styling
function showValidationError(message) {
  // Remove existing validation errors
  const existingError = document.getElementById('validation-error');
  if (existingError) {
    existingError.remove();
  }
  
  // Create error message
  const errorDiv = document.createElement('div');
  errorDiv.id = 'validation-error';
  errorDiv.style.cssText = `
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #dc3545;
    color: white;
    padding: 12px 20px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
    z-index: 10000;
    max-width: 90%;
    text-align: center;
  `;
  errorDiv.innerHTML = `⚠️ ${message}`;
  
  document.body.appendChild(errorDiv);
  
  // Auto-remove after 5 seconds
  setTimeout(() => {
    if (errorDiv && errorDiv.parentNode) {
      errorDiv.remove();
    }
  }, 5000);
}

// Handle file upload
function handleFileUpload() {
  const buttonSelectQuantity = document.getElementById('button-select-quantity');
  const fileSelectQuantity = document.getElementById('file-select-quantity');
  const fileNameDisplay = document.getElementById('file-name-display');
  
  if (buttonSelectQuantity && fileSelectQuantity && !buttonSelectQuantity.dataset.sfUploadBound) {
    buttonSelectQuantity.dataset.sfUploadBound = 'true';
    buttonSelectQuantity.addEventListener('click', function() {
      fileSelectQuantity.click();
    });
  }
  
  if (fileSelectQuantity && fileNameDisplay && !fileSelectQuantity.dataset.sfUploadBound) {
    fileSelectQuantity.dataset.sfUploadBound = 'true';
    fileSelectQuantity.addEventListener('change', function() {
      if (this.files && this.files[0]) {
        const file = this.files[0];

        if (validateFileForMobile(file)) {
          fileNameDisplay.textContent = file.name;
          updateStep2UploadSection();
          syncBuilderExperience();
        } else {
          alert('Please upload AI, EPS, PDF, PNG, JPG, TIFF, or SVG artwork under 10 MB.');
          this.value = '';
        }
      }
    });
  }
}

// Handle email artwork later checkbox
function handleEmailArtwork() {
  const emailCheckbox = document.getElementById('email-your-artwork-later');
  const instructionsContainer = document.getElementById('instructions-container');
  const emailHidden = document.getElementById('email-later-hidden');
  const instructionsHidden = document.getElementById('instructions-hidden');
  const instructionsText = document.getElementById('instructions-text');
  
  if (emailCheckbox && !emailCheckbox.dataset.sfEmailBound) {
    emailCheckbox.dataset.sfEmailBound = 'true';
    emailCheckbox.addEventListener('change', function() {
      if (this.checked) {
        if (instructionsContainer) instructionsContainer.style.display = 'block';
        if (emailHidden) {
          emailHidden.checked = true;
          emailHidden.value = 'Yes';
        }
      } else {
        if (instructionsContainer) instructionsContainer.style.display = 'none';
        if (emailHidden) {
          emailHidden.checked = false;
          emailHidden.value = 'No';
        }
      }
      syncBuilderExperience();
    });
  }
  
  // Sync instructions text
  if (instructionsText && instructionsHidden && !instructionsText.dataset.sfInstructionsBound) {
    instructionsText.dataset.sfInstructionsBound = 'true';
    instructionsText.addEventListener('input', function() {
      instructionsHidden.value = this.value;
    });
  }
}

// Add event listeners safely
function addEventListenerSafe(elementId, event, handler) {
  const element = document.getElementById(elementId);
  if (element) {
    element.addEventListener(event, handler);
  }
}

function addEventListenerSafeQuery(selector, event, handler) {
  const elements = document.querySelectorAll(selector);
  elements.forEach(element => {
    element.addEventListener(event, handler);
  });
}







// Read metafields and override defaults
function readMetafieldOverrides() {
  const overrides = {};
  const pathProductType = getSfProductTypeFromPath();
  if (pathProductType) {
    overrides.productType = pathProductType;
  }
  
  // Check if we're on a product page with metafields
  if (typeof window.meta !== 'undefined' && window.meta.product && window.meta.product.metafields) {
    const metafields = window.meta.product.metafields;
    
    // Read product type
    if (!pathProductType && metafields['custom.calculator_product_type']) {
      overrides.productType = metafields['custom.calculator_product_type'];
    }
    
    // Read shape
    if (metafields['custom.calculator_shape']) {
      overrides.shape = metafields['custom.calculator_shape'];
    }
    
    // Read material
    if (metafields['custom.calculator_material']) {
      overrides.material = metafields['custom.calculator_material'];
    }
    
        // Read deal/override (bool-ish)
    if (metafields['custom.calculator_override1']) {
      overrides.dealMode = sfTruthyValue(metafields['custom.calculator_override1']);
    }
    // Read base price (number)
    if (metafields['custom.override_price2']) {
      overrides.basePrice = parseFloat(metafields['custom.override_price2']) || 0;
    }
    // Optional: override size/qty (display + pass-through)
    if (metafields['custom.override_size1']) {
      overrides.size = String(metafields['custom.override_size1']);
    }
    if (metafields['custom.override_qty1']) {
      overrides.qty = parseInt(metafields['custom.override_qty1'], 10) || null;
    }


  }
  
  return overrides;
}






// FORCE INITIAL DEFAULTS FUNCTION - FIXED
function forceInitialDefaults() {
  // console.log(('Forcing initial defaults...');
    if (hasSfSizeQtyOverrides()) { return; }

  
const checked = sel => document.querySelector(sel);
const visible = el => el && !el.disabled && el.offsetParent !== null;
const safeCheck = el => { el.checked = true; el.dispatchEvent(new Event('change',{bubbles:true})); };





   // Get metafield overrides first
  const overrides = readMetafieldOverrides();
  
  // Apply product type override if specified. The markup defaults to Sticker,
  // so canonical product URLs must be allowed to replace an existing checked state.
if (overrides.productType === 'Custom Label') {
  const labelRadio = document.getElementById('custom-label');
  if (labelRadio) { labelRadio.checked = true; }
} else if (overrides.productType === 'Custom Sticker') {
  const stickerRadio = document.getElementById('custom-sticker');
  if (stickerRadio) { stickerRadio.checked = true; }
} else if (!checked('input[name="product-type"]:checked')) {
  // Force sticker defaults
  const stickerRadio = document.getElementById('custom-sticker');
  if (stickerRadio) { stickerRadio.checked = true; }

  
if (!checked('input[name="properties[Select Your Shape]"]:checked')) {
  const shapeToSelect = overrides.shape || 'Die-cut';
  const shapeElement = document.getElementById(shapeToSelect) || document.getElementById('Die-cut');
  if (visible(shapeElement)) safeCheck(shapeElement);
}

  
if (!checked('input[name="properties[Select Your Material]"]:checked')) {
  const materialToSelect = overrides.material || 'Vinyl';
  const materialElement = document.getElementById(materialToSelect) || document.getElementById('Vinyl');
  if (visible(materialElement)) safeCheck(materialElement);
}

  
  const nonEnhanced = document.getElementById('Non-Enhanced');
  if (nonEnhanced) {
    nonEnhanced.checked = true;
    // console.log(('✓ Non-Enhanced selected');
  }
  
  const stickerQty = document.getElementById('sticker-quantity');
  if (stickerQty) {
    stickerQty.value = '50';
    // console.log(('✓ Sticker quantity set to 50');
  }
  
  const stickerSize = document.getElementById('select-size-sticker');
  if (stickerSize) {
    stickerSize.value = '3 x 3';
    // console.log(('✓ Sticker size set to 3x3');
  }
  
  // Force label defaults (for when user switches)
  const circleLabel = document.getElementById('Circle-Label');
  if (circleLabel) {
    circleLabel.checked = true;
    // console.log(('✓ Circle label selected');
  }
  
  const labelQty = document.getElementById('label-quantity');
  if (labelQty) {
    labelQty.value = '50';
    // console.log(('✓ Label quantity set to 50');
  }
  
  const circleSize = document.getElementById('select-size-circle-label');
  if (circleSize) {
    circleSize.value = '2';
    // console.log(('✓ Circle size set to 2');
  }
  
// Only force Matte for labels if NO metafield material was provided
if (!(window.sfOverrides && window.sfOverrides.material)) {
  const matteLabel = document.getElementById('Matte-Laminate-Label-CS');
  if (matteLabel) {
    matteLabel.checked = true;
  }
}

  
  // FIXED: Add label cut-type default
  const onSheetLabel = document.getElementById('On-Sheet-Label');
  if (onSheetLabel) {
    onSheetLabel.checked = true;
    // console.log(('✓ On-Sheet-Label selected');
  }
  
  // console.log(('Initial defaults forced!');
}
}

// VERIFY AND FIX DEFAULTS IF THEY GOT OVERRIDDEN - FIXED
function verifyAndFixDefaults() {
  // console.log(('Verifying defaults are still set...');
    if (hasSfSizeQtyOverrides()) { return; }

  // Check sticker quantity
  const stickerQty = document.getElementById('sticker-quantity');
  if (stickerQty && stickerQty.value !== '50') {
    // console.log(('⚠️ Sticker quantity was changed, fixing...');
    stickerQty.value = '50';
  }
  
  // Check label quantity - FORCE IT
  const labelQty = document.getElementById('label-quantity');
  if (labelQty && labelQty.value !== '50') {
    // console.log(('⚠️ Label quantity was changed, fixing...');
    labelQty.value = '50';
    labelQty.dispatchEvent(new Event('change')); // Trigger change event
  }
  
  // Check if Die-cut is still selected
if (!window.sfOverridesApplied) {
  const diecut = document.getElementById('Die-cut');
  if (diecut && !diecut.checked) { diecut.checked = true; }
}

  
  // Check if Vinyl is still selected
if (!window.sfOverridesApplied) {
  const vinyl = document.getElementById('Vinyl');
  if (vinyl && !vinyl.checked) { vinyl.checked = true; }
}

  
  // FIXED: Only check cut-type for currently active product type
  const productType = document.querySelector('input[name="product-type"]:checked')?.value;
  
if (!window.sfOverridesApplied) {
  if (productType === 'Custom Sticker') {
    const onSheet = document.getElementById('On-Sheet');
    if (onSheet && !onSheet.checked) { onSheet.checked = true; }
  } else if (productType === 'Custom Label') {
    const onSheetLabel = document.getElementById('On-Sheet-Label');
    if (onSheetLabel && !onSheetLabel.checked) { onSheetLabel.checked = true; }
  }
}

  
  // Check if Non-Enhanced is still selected
  const nonEnhanced = document.getElementById('Non-Enhanced');
  if (nonEnhanced && !nonEnhanced.checked) {
    // console.log(('⚠️ Non-Enhanced was unchecked, fixing...');
    nonEnhanced.checked = true;
  }
  
  // Check sticker size
  const stickerSize = document.getElementById('select-size-sticker');
  if (stickerSize && stickerSize.value !== '3 x 3') {
    // console.log(('⚠️ Sticker size was changed, fixing...');
    stickerSize.value = '3 x 3';
  }
  
  const circleLabel = document.getElementById('Circle-Label');
  if (circleLabel && !circleLabel.checked) {
    // console.log(('⚠️ Circle label was unchecked, fixing...');
    circleLabel.checked = true;
  }
  
  const circleSize = document.getElementById('select-size-circle-label');
  if (circleSize && circleSize.value !== '2') {
    // console.log(('⚠️ Circle size was changed, fixing...');
    circleSize.value = '2';
  }
  
// Don't override if a metafield material exists
if (!(window.sfOverrides && window.sfOverrides.material)) {
  const matteLabel = document.getElementById('Matte-Laminate-Label-CS');
  if (matteLabel && !matteLabel.checked) {
    matteLabel.checked = true;
  }
}

  
  // console.log(('✅ Defaults verification complete');
}

// Setup all event listeners in separate function with immediate price updates
function setupEventListeners() {
  // console.log(('Setting up event listeners...');
  bindProductTypeRedirectClicks();
  
  // Product type toggle
  addEventListenerSafe('custom-sticker', 'change', function(event) {
    // console.log(('🔄 Product type changed to sticker');
    if (redirectToProductTypePage(this.value, event)) return;
    toggleProductType();
  });
  
  addEventListenerSafe('custom-label', 'change', function(event) {
    // console.log(('🔄 Product type changed to label');
    if (redirectToProductTypePage(this.value, event)) return;
    toggleProductType();
  });
  
  // Size changes for stickers - IMMEDIATE price update with multiple triggers
  addEventListenerSafe('select-size-sticker', 'change', function() {
    try {
      // console.log(('📏 Sticker size changed to:', this.value);
      handleCustomSize();
      
      // IMMEDIATE price update
      updatePriceDisplay();
      
      // Additional updates with slight delays to override any interference
      setTimeout(() => {
        updatePriceDisplay();
        // console.log(('🔄 Secondary price update after size change');
      }, 50);
      
      setTimeout(() => {
        updatePriceDisplay();
        // console.log(('🔄 Tertiary price update after size change');
      }, 200);
      
    } catch (error) {
      // console.log(('Error in sticker size change:', error);
    }
  });
  
  // Quantity changes - IMMEDIATE price update
  addEventListenerSafe('sticker-quantity', 'change', function() {
    try {
      // console.log(('🔢 Sticker quantity changed to:', this.value);
      // IMMEDIATE price update
      updatePriceDisplay();
    } catch (error) {
      // console.log(('Error in sticker quantity change:', error);
    }
  });
  
  // Custom size inputs for stickers
  handleCustomSizeInputs();
  
  // Label size changes - IMMEDIATE price update
  addEventListenerSafe('select-size-circle-label', 'change', function() {
    try {
      // console.log(('📏 Circle label size changed to:', this.value);
      updateMaterialPricing();
      // IMMEDIATE price update
      updatePriceDisplay();
    } catch (error) {
      // console.log(('Error in circle label size change:', error);
    }
  });
  
  addEventListenerSafe('select-size-square-label', 'change', function() {
    try {
      // console.log(('📏 Square label size changed to:', this.value);
      updateMaterialPricing();
      // IMMEDIATE price update
      updatePriceDisplay();
    } catch (error) {
      // console.log(('Error in square label size change:', error);
    }
  });
  
  addEventListenerSafe('select-size-oval-label', 'change', function() {
    try {
      // console.log(('📏 Oval label size changed to:', this.value);
      // IMMEDIATE price update
      updatePriceDisplay();
    } catch (error) {
      // console.log(('Error in oval label size change:', error);
    }
  });
  
  addEventListenerSafe('select-size-rectangle-label', 'change', function() {
    try {
      // console.log(('📏 Rectangle label size changed to:', this.value);
      // IMMEDIATE price update
      updatePriceDisplay();
    } catch (error) {
      // console.log(('Error in rectangle label size change:', error);
    }
  });
  
  addEventListenerSafe('label-quantity', 'change', function() {
    try {
      // console.log(('🔢 Label quantity changed to:', this.value);
      // IMMEDIATE price update
      updatePriceDisplay();
    } catch (error) {
      // console.log(('Error in label quantity change:', error);
    }
  });
  
  // Label shape changes with immediate price updates
  addEventListenerSafeQuery('input[name="properties[Label Shape]"]', 'change', function() {
    try {
      // console.log(('🏷️ Label shape changed to:', this.value);
      updateLabelSizeOptions();
      updateLabelMaterials();
      updateMaterialPricing();
      updateStep2UploadSection();
      // IMMEDIATE price update
      updatePriceDisplay();
    } catch (error) {
      // console.log(('Error in label shape change:', error);
    }
  });
  
  // Material and other option changes - IMMEDIATE price updates - FIXED
  addEventListenerSafeQuery('input[name="properties[Select Your Material]"]', 'change', function() {
    try {
      // console.log(('🎨 Sticker material changed to:', this.value);
      // IMMEDIATE price update
      updatePriceDisplay();
      
      // Additional update with delay to ensure it takes effect
      setTimeout(() => {
        updatePriceDisplay();
        // console.log(('🔄 Secondary price update after material change');
      }, 50);
    } catch (error) {
      // console.log(('Error in sticker material change:', error);
    }
  });
  
  addEventListenerSafeQuery('input[name="properties[Label Material]"]', 'change', function() {
    try {
      // console.log(('🎨 Label material changed to:', this.value);
      // IMMEDIATE price update
      updatePriceDisplay();
    } catch (error) {
      // console.log(('Error in label material change:', error);
    }
  });
  
  addEventListenerSafeQuery('input[name="properties[Select Your Shape]"]', 'change', function() {
    try {
      // console.log(('⭐ Sticker shape changed to:', this.value);
      // IMMEDIATE price update
      updateStep2UploadSection();
      updatePriceDisplay();
    } catch (error) {
      // console.log(('Error in sticker shape change:', error);
    }
  });
  
  addEventListenerSafeQuery('input[name="properties[Enhance Image Quality]"]', 'change', function() {
    try {
      // console.log(('✨ Enhancement changed to:', this.value);
      // IMMEDIATE price update
      updatePriceDisplay();
    } catch (error) {
      // console.log(('Error in enhance quality change:', error);
    }
  });
  
  // console.log(('✅ Event listeners set up complete');
}

// Monitor for external interference with price display
function monitorPriceDisplay() {
  const priceDisplay = document.getElementById('price-display');
  if (!priceDisplay) return;
  
  // Set up a mutation observer to detect if something else changes the price
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        // console.log(('🔍 Price display was modified externally:', priceDisplay.textContent);
        
        // If it was set to $0.00, recalculate and restore
        if (priceDisplay.textContent === '$0.00') {
          // console.log(('⚠️ Price was reset to $0.00, restoring...');
          setTimeout(() => {
            updatePriceDisplay();
          }, 10);
        }
      }
    });
  });
  
  observer.observe(priceDisplay, {
    childList: true,
    characterData: true,
    subtree: true
  });
  
  // console.log(('👁️ Price display monitor activated');
}







// Force refresh visual state of radio buttons
function forceRefreshRadioStates() {
  // console.log(('🔄 Forcing refresh of radio button visual states...');
  
  // Force refresh sticker cut-type visual state
  const onSheet = document.getElementById('On-Sheet');
  if (onSheet && onSheet.checked) {
    // Temporarily uncheck and recheck to force CSS refresh
    onSheet.checked = false;
    setTimeout(() => {
      onSheet.checked = true;
      // console.log(('🔄 Refreshed sticker cut-type visual state');
    }, 10);
  }
  
  // Force refresh label cut-type visual state
  const onSheetLabel = document.getElementById('On-Sheet-Label');
  if (onSheetLabel && onSheetLabel.checked) {
    // Temporarily uncheck and recheck to force CSS refresh
    onSheetLabel.checked = false;
    setTimeout(() => {
      onSheetLabel.checked = true;
      // console.log(('🔄 Refreshed label cut-type visual state');
    }, 10);
  }
  
  // Also refresh other important radio buttons
const diecut = document.getElementById('Die-cut');
if (!window.sfOverridesApplied && diecut && !document.querySelector('input[name="properties[Select Your Shape]"]:checked')) {
  diecut.checked = true;
}

const stickerQtySelect = document.getElementById('sticker-quantity');
if (!hasSfSizeQtyOverrides() && stickerQtySelect) stickerQtySelect.value = '50';

  
  const vinyl = document.getElementById('Vinyl');
  if (vinyl && vinyl.checked) {
    vinyl.checked = false;
    setTimeout(() => {
      vinyl.checked = true;
      // console.log(('🔄 Refreshed material visual state');
    }, 20);
  }
}

// SAFE ELEMENT MANIPULATION TO PREVENT NULL ERRORS
function safeElementManipulation(elementId, action) {
  try {
    const element = document.getElementById(elementId);
    if (element && action) {
      action(element);
    }
  } catch (error) {
    // console.log((`Safe manipulation failed for ${elementId}:`, error);
  }
}

function getDraftOrderEndpoint() {
  const liveEndpoint = 'https://calculator.stickerfreaksllc.com/api.php';
  const testEndpoint = 'https://calculator.stickerfreaksllc.com/draft-api.php';
  const params = new URLSearchParams(window.location.search);

  return params.get('draft_api') === 'test' ? testEndpoint : liveEndpoint;
}

function setSfCheckoutLoading(isLoading) {
  const buttons = [
    document.getElementById('add-to-cart-btn'),
    document.getElementById('sf-step-submit-btn')
  ].filter(Boolean);

  buttons.forEach(button => {
    button.disabled = isLoading;
    button.classList.toggle('sf-checkout-loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (isLoading) {
      button.innerHTML = [
        '<span class="sf-checkout-spinner" aria-hidden="true"></span>',
        '<span class="sf-checkout-loading-text">Creating order...</span>'
      ].join('');
    } else {
      button.textContent = 'Checkout';
    }
  });

  document.querySelector('.sf-builder-page')?.classList.toggle('sf-is-creating-order', isLoading);
}

function resetSfCheckoutLoading() {
  setSfCheckoutLoading(false);
  if (typeof syncBuilderExperience === 'function') syncBuilderExperience();
}

function sfCleanOverrideValue(value) {
  if (Array.isArray(value)) return sfCleanOverrideValue(value[0]);
  return String(value || '').trim();
}

function getSfBuilderProductType() {
  const pathProductType = getSfProductTypeFromPath();
  if (pathProductType) return pathProductType;

  const checkedType = document.querySelector('input[name="product-type"]:checked')?.value;
  if (checkedType === 'Custom Label' || checkedType === 'Custom Sticker') {
    return checkedType;
  }

  const overrides = { ...readMetafieldOverrides(), ...(window.sfOverrides || {}) };
  const overrideType = sfCleanOverrideValue(overrides.productType).toLowerCase();
  if (overrideType.includes('label')) return 'Custom Label';
  if (overrideType.includes('sticker')) return 'Custom Sticker';
  return 'Custom Sticker';
}

const SF_PRODUCT_TYPE_VARIANTS = {
  'Custom Sticker': {
    productId: '1036669691566',
    variantId: '54515787202882'
  },
  'Custom Label': {
    productId: '10366697046338',
    variantId: '54515787596098'
  }
};

function setSfProductTypeVariant(formData, productType = getSfBuilderProductType()) {
  const target = SF_PRODUCT_TYPE_VARIANTS[productType] || SF_PRODUCT_TYPE_VARIANTS['Custom Sticker'];
  if (!target) return;

  formData.set('id', target.variantId);
  formData.set('variant_id', target.variantId);
  formData.set('product_id', target.productId);
  formData.set('SF_Product_Type_Variant_ID', target.variantId);
  formData.set('SF_Product_Type_Product_ID', target.productId);
}

function getSfVisibleCheckedValue(selector) {
  const inputs = Array.from(document.querySelectorAll(selector));
  const visibleChecked = inputs.find(input => input.checked && input.offsetParent !== null);
  const checked = inputs.find(input => input.checked);
  return sfCleanOverrideValue((visibleChecked || checked)?.value);
}

function getSfLabelSizeForShape(shape) {
  const normalizedShape = sfCleanOverrideValue(shape);
  const selectorId = {
    Circle: 'select-size-circle-label',
    Square: 'select-size-square-label',
    Oval: 'select-size-oval-label',
    Rectangle: 'select-size-rectangle-label'
  }[normalizedShape];
  const value = sfCleanOverrideValue(selectorId ? document.getElementById(selectorId)?.value : '');
  if (!value) return '';
  return (normalizedShape === 'Circle' || normalizedShape === 'Square') ? `${value}"` : value;
}

function getSfStickerSizeValue() {
  const sizeSelect = document.getElementById('select-size-sticker');
  const selectedSize = sfCleanOverrideValue(sizeSelect?.value);
  if (selectedSize === 'Custom Size') {
    const width = sfCleanOverrideValue(document.getElementById('custom-width-input')?.value);
    const height = sfCleanOverrideValue(document.getElementById('custom-height-input')?.value);
    return (width && height) ? `${width}" x ${height}"` : '';
  }

  return selectedSize;
}

function getSfEnhancementValue() {
  return getSfVisibleCheckedValue('input[name="properties[Enhance Image Quality]"]') || 'Non-Enhanced';
}

function appendSfServerPricingFields(formData, productType) {
  const overrides = { ...readMetafieldOverrides(), ...(window.sfOverrides || {}) };
  const finalProductType = productType || getSfBuilderProductType();
  const dealMode = sfTruthyValue(overrides.dealMode);
  formData.set('Product_Type', finalProductType);
  formData.set('Enhance Image Quality', getSfEnhancementValue());

  if (dealMode) {
    formData.set('SF_Deal_Mode', '1');
    formData.set('SF_Base_Price', String(parseFloat(overrides.basePrice || 0) || 0));
  } else {
    formData.delete('SF_Deal_Mode');
    formData.delete('SF_Base_Price');
  }

  if (finalProductType === 'Custom Label') {
    const shape = getSfVisibleCheckedValue('input[name="properties[Label Shape]"]') || sfCleanOverrideValue(overrides.shape);
    const size = getSfLabelSizeForShape(shape) || sfCleanOverrideValue(overrides.size);
    const material = getSfVisibleCheckedValue('input[name="properties[Label Material]"]') || sfCleanOverrideValue(overrides.material) || 'Matte Laminate';
    const quantity = sfCleanOverrideValue(document.getElementById('label-quantity')?.value) || sfCleanOverrideValue(overrides.qty) || '50';

    if (shape) formData.set('Label Shape', shape);
    if (size) formData.set('Label Size', size);
    if (material) formData.set('Label Material', material);
    if (quantity) formData.set('Quantity', quantity);

    formData.delete('Sticker Shape');
    formData.delete('Sticker Size');
    formData.delete('Sticker Material');
    formData.delete('Final Size');
    formData.delete('Cut Type');
  } else {
    const shape = getSfVisibleCheckedValue('input[name="properties[Select Your Shape]"]') || sfCleanOverrideValue(overrides.shape);
    const size = getSfStickerSizeValue() || sfCleanOverrideValue(overrides.size);
    const material = getSfVisibleCheckedValue('input[name="properties[Select Your Material]"]') || sfCleanOverrideValue(overrides.material);
    const quantity = sfCleanOverrideValue(document.getElementById('sticker-quantity')?.value) || sfCleanOverrideValue(overrides.qty) || '50';

    if (shape) formData.set('Sticker Shape', shape);
    if (size) {
      formData.set('Sticker Size', size);
    }
    if (material) formData.set('Sticker Material', material);
    if (quantity) formData.set('Quantity', quantity);

    formData.delete('Label Shape');
    formData.delete('Label Size');
    formData.delete('Label Material');
  }

  formData.delete('Cut Type');
  formData.delete('Cut_Type');
}

// Initialize all event listeners - FIXED VERSION
function initializeProductCustomizer() {
  // console.log(('DOM loaded, starting initialization...');
  sfLoadPricingConfig();
  
  // Set up event listeners first
  setupEventListeners();
  setupDedicatedBuilderFlow();
  bindBuilderProgressNavigation();
  
  // Initialize handlers
  handleStepNavigation();

  applySfOverrides?.();        // run overrides first
window.sfOverridesApplied = true;


document.querySelectorAll('input[name="properties[Cut Type]"]').forEach(input => {
  input.closest('.option-card, .selection-card, label, div')?.remove();
});


// Handle Add to Cart button
// Handle Add to Cart button - Draft Order Integration
if (!window.sfAddToCartDelegated) {
  window.sfAddToCartDelegated = true;
  document.addEventListener('click', async function(e) {
    const addToCartBtn = e.target.closest?.('#add-to-cart-btn');
    if (!addToCartBtn) return;
    e.preventDefault();
    
    // Validation
    const fileSelectQuantity = document.getElementById('file-select-quantity');
    const emailLaterCheckbox = document.getElementById('email-your-artwork-later');
    
    // Check if file uploaded OR email later checked
    const hasFile = fileSelectQuantity && fileSelectQuantity.files && fileSelectQuantity.files.length > 0;
    const emailLater = emailLaterCheckbox && emailLaterCheckbox.checked;
    const hasCustomDesign = Boolean(window.customDesignData?.image || document.getElementById('designDataInput')?.value);
    
    if (!hasFile && !emailLater && !hasCustomDesign) {
      alert('Please upload your artwork file or check "Email your artwork later"');
      return;
    }
    
    // Get calculated price
    const price = calculatePrice();
    if (!price || price <= 0) {
      alert('Please configure your product options');
      return;
    }
    
    setSfCheckoutLoading(true);
    const sfCheckoutClientStart = performance.now();
    
    // Collect all form data
    const formData = new FormData();


    
    // Add calculated price
    formData.append('calculated_price', price);
    
// Add ONLY relevant form fields based on product type
const form = document.getElementById('product-form');
const productType = getSfBuilderProductType();
setSfProductTypeVariant(formData, productType);

// Add product type FIRST so it appears at the top
if (productType) {
  formData.append('Product_Type', productType);
}

      // Deal-mode: force size/qty from metafields for display/payload
      const ovr = { ...readMetafieldOverrides(), ...(window.sfOverrides || {}) };
      if (ovr.size) { formData.set('Final Size', String(ovr.size)); }
      if (ovr.qty)  { formData.set('Quantity', String(ovr.qty)); }


const sfArtworkPrepStart = performance.now();
const hasCustomDesignPayload = await appendSfCustomDesignData(formData);
if (!hasCustomDesignPayload) {
  await appendSfArtworkFiles(formData);
}
formData.set('SF_Client_Artwork_Prep_Ms', String(Math.round(performance.now() - sfArtworkPrepStart)));

// Add artwork info

const emailCheckbox = document.getElementById('email-your-artwork-later');






if (form && productType) {
  const inputs = form.querySelectorAll('input, select, textarea');
  inputs.forEach(function(input) {
    if (input.name && input.name.startsWith('properties[') && !input.disabled) {
      let propertyName = input.name.replace('properties[', '').replace(']', '');
      
      // Filter based on product type
      let shouldInclude = false;
      
      if (productType === 'Custom Sticker') {
        // Only include sticker-related fields
        if (propertyName === 'Select Your Shape' || 
            propertyName === 'Select Size' ||           // ✅ Added this
            propertyName === 'Select Your Material' || 
            propertyName === 'Enhance Image Quality' || 
            propertyName === 'Quantity' ||
            propertyName === 'Email your artwork later' ||
            propertyName === 'Instructions (Optional)') {
          shouldInclude = true;
          
          // ✅ Clean up property names for stickers
          if (propertyName === 'Select Your Shape') propertyName = 'Sticker Shape';
          if (propertyName === 'Select Size') propertyName = 'Sticker Size';
          if (propertyName === 'Select Your Material') propertyName = 'Sticker Material';
        }



        
      } else if (productType === 'Custom Label') {
        // Only include label-related fields
        if (propertyName.includes('Label') || 
  
            propertyName === 'Enhance Image Quality' || 
            propertyName === 'Quantity' ||
            propertyName === 'Email your artwork later' ||
            propertyName === 'Instructions (Optional)') {
          shouldInclude = true;
          
          // ✅ Clean up property names for labels
          if (propertyName === 'Label Shape') propertyName = 'Label Shape';
          if (propertyName === 'Label Size') propertyName = 'Label Size';
          if (propertyName === 'Label Material') propertyName = 'Label Material';
        }
      }

// Replace the existing label size collection section with this:

if (productType === 'Custom Label') {
  // 🔹 Get correct Label Size based on shape selected
  const shape = document.querySelector('input[name="properties[Label Shape]"]:checked')?.value;
  let labelSizeValue = '';
  let labelSizeName = '';

  if (shape === 'Circle') {
      const sizeSelect = document.getElementById('select-size-circle-label');
      if (sizeSelect && sizeSelect.value) {
          labelSizeValue = sizeSelect.value + '"';
          labelSizeName = 'Label Size';
      }
  } else if (shape === 'Square') {
      const sizeSelect = document.getElementById('select-size-square-label');
      if (sizeSelect && sizeSelect.value) {
          labelSizeValue = sizeSelect.value + '"';
          labelSizeName = 'Label Size';
      }
  } else if (shape === 'Oval') {
      const sizeSelect = document.getElementById('select-size-oval-label');
      if (sizeSelect && sizeSelect.value) {
          labelSizeValue = sizeSelect.value;
          labelSizeName = 'Label Size';
      }
  } else if (shape === 'Rectangle') {
      const sizeSelect = document.getElementById('select-size-rectangle-label');
      if (sizeSelect && sizeSelect.value) {
          labelSizeValue = sizeSelect.value;
          labelSizeName = 'Label Size';
      }
  }

  // Set the label size in form data
  if (labelSizeValue && labelSizeName) {
      formData.set(labelSizeName, labelSizeValue);
      console.log('Setting label size:', labelSizeName, '=', labelSizeValue);
  }
}

      
      
      if (shouldInclude) {
        if (input.type === 'checkbox' || input.type === 'radio') {
          if (input.checked) {
            formData.append(propertyName, input.value || 'Yes');
          }
        } else if (input.type === 'file') {
          return;
} else if (input.value) {
  // Special handling for Quantity to avoid duplicate collection
  if (propertyName === 'Quantity') {
    // Only collect from the correct quantity selector based on product type
    if ((productType === 'Custom Sticker' && input.id === 'sticker-quantity') ||
        (productType === 'Custom Label' && input.id === 'label-quantity')) {
      formData.append(propertyName, input.value);
    }
  } else {
    formData.append(propertyName, input.value);
  }
}
      }
    }
  });
}
    

    // Add custom size if selected
    const sizeSelect = document.getElementById('select-size-sticker');
    if (sizeSelect && sizeSelect.value === 'Custom Size') {
      const customWidth = document.getElementById('custom-width-input');
      const customHeight = document.getElementById('custom-height-input');
      
      if (customWidth && customHeight && customWidth.value && customHeight.value) {
        formData.append('Final Size', `${customWidth.value}" x ${customHeight.value}"`);
      }
    }

    appendSfServerPricingFields(formData, productType);
    formData.set('SF_Client_Payload_Ready_Ms', String(Math.round(performance.now() - sfCheckoutClientStart)));

    

    
// Send to your API
fetch(getDraftOrderEndpoint(), {
  method: 'POST',
  body: formData,
  // Don't set Content-Type header - let browser handle it for FormData
})
    .then(response => response.json())
    .then(data => {
      if (data.success && data.invoice_url) {
        // Success! Redirect to Shopify checkout
        // console.log(('Draft order created successfully');
        window.location.href = data.invoice_url;
      } else {
        // Error occurred
        console.error('API Error:', data);
        const detailText = data.pricing_details
          ? Object.entries(data.pricing_details)
              .filter(([, value]) => value !== null && value !== '' && typeof value !== 'undefined')
              .map(([key, value]) => `${key}: ${value}`)
              .join('\n')
          : '';
        alert(`${data.error || 'Something went wrong. Please try again.'}${detailText ? `\n\nPricing details:\n${detailText}` : ''}`);
        
        resetSfCheckoutLoading();
      }
    })
    .catch(error => {
      console.error('Network Error:', error);
      alert('Network error. Please check your connection and try again.');
      resetSfCheckoutLoading();
    });
  });
}

// Generate order summary for the draft order
function generateOrderSummary() {
  const productType = document.querySelector('input[name="product-type"]:checked')?.value || 'Custom Product';
  const shape = document.querySelector('input[name="properties[Select Your Shape]"]:checked')?.value || 
                document.querySelector('input[name="properties[Label Shape]"]:checked')?.value || '';
  
  // Get size
  let size = '';
  const dimensions = getDimensions();
  if (dimensions) {
    if (dimensions.sizeKey) {
      size = dimensions.sizeKey + (dimensions.shape === 'Circle' || dimensions.shape === 'Square' ? '"' : '');
    } else {
      size = `${dimensions.width}" x ${dimensions.height}"`;
    }
  }
  
  const material = document.querySelector('input[name="properties[Select Your Material]"]:checked')?.value || 
                   document.querySelector('input[name="properties[Label Material]"]:checked')?.value || '';
  const quantity = getQuantity() || 1;
  const enhancement = document.querySelector('input[name="properties[Enhance Image Quality]"]:checked')?.value || 'Non-Enhanced';
  
  const summary = [
    `Product: ${productType}`,
    shape ? `Shape: ${shape}` : '',
    size ? `Size: ${size}` : '',
    material ? `Material: ${material}` : '',
    `Quantity: ${quantity}`,
    enhancement !== 'Non-Enhanced' ? `Enhancement: ${enhancement}` : ''
  ].filter(item => item).join(', ');
  
  return summary;
}






















  
  handleFileUpload();
  handleEmailArtwork();
  syncBuilderExperience();





  
  
  // FORCE DEFAULTS AFTER A DELAY TO PREVENT OVERRIDE
  setTimeout(() => {
    ('Setting defaults after delay...');
    forceInitialDefaults();
    toggleProductType();
    updatePriceDisplay();
  }, 250);
  
  // DOUBLE CHECK AND RE-APPLY DEFAULTS IF NEEDED
  setTimeout(() => {
    // console.log(('Double-checking defaults...');
    verifyAndFixDefaults();
    
    // TRIPLE check label quantity specifically
    const labelQty = document.getElementById('label-quantity');
    if (!hasSfSizeQtyOverrides() && labelQty && (!labelQty.value || labelQty.value === '')) {
      // console.log(('🚨 Label quantity still empty, force setting...');
      labelQty.value = '50';
      labelQty.selectedIndex = 1; // Force select the 50 option
    }
    
    updatePriceDisplay();
  }, 500);
  
  // FINAL CHECK after everything should be loaded with enhanced material selection
  setTimeout(() => {
    // console.log(('Final verification...');
    const stickerQty = document.getElementById('sticker-quantity');
    const labelQty = document.getElementById('label-quantity');
    
    if (!hasSfSizeQtyOverrides() && stickerQty && stickerQty.value !== '50') {
      stickerQty.value = '50';
      // console.log(('🔧 Final fix: sticker quantity');
    }
    
    if (!hasSfSizeQtyOverrides() && labelQty && labelQty.value !== '50') {
      labelQty.value = '50';
      labelQty.selectedIndex = 1; // Force select option 2 (50 pcs)
      // console.log(('🔧 Final fix: label quantity');
    }
    
    // FIXED: Only check cut-type for currently active product type
    const productType = document.querySelector('input[name="product-type"]:checked')?.value;
    
    if (productType === 'Custom Sticker') {
      const onSheet = document.getElementById('On-Sheet');
      if (onSheet && !onSheet.checked) {
        onSheet.checked = true;
        // console.log(('🔧 Final fix: sticker cut-type');
      }
    } else if (productType === 'Custom Label') {
      const onSheetLabel = document.getElementById('On-Sheet-Label');
      if (onSheetLabel && !onSheetLabel.checked) {
        onSheetLabel.checked = true;
        // console.log(('🔧 Final fix: label cut-type');
      }
    }
    
    // FINAL CHECK FOR MATERIAL SELECTION
    if (productType === 'Custom Label') {
      const labelShape = document.querySelector('input[name="properties[Label Shape]"]:checked')?.value;
      
      if (labelShape === 'Circle' || labelShape === 'Square' || !labelShape) {
        const matteCS = document.getElementById('Matte-Laminate-Label-CS');
        if (matteCS && !matteCS.checked) {
          matteCS.checked = true;
          // console.log(('🎨 Final fix: Matte Laminate for Circle/Square');
        }
      } else if (labelShape === 'Oval' || labelShape === 'Rectangle') {
        const matteOR = document.getElementById('Matte-Laminate-Label-OR');
        if (matteOR && !matteOR.checked) {
          matteOR.checked = true;
          // console.log(('🎨 Final fix: Matte Laminate for Oval/Rectangle');
        }
      }
    }
    
    updatePriceDisplay();
    
// FORCE REFRESH VISUAL STATES - This is the key fix!
setTimeout(() => {
  forceRefreshRadioStates();
  
  // HIDE LOADING OVERLAY - Everything is ready!
  const formLoading = document.getElementById('product-form-loading');
  if (formLoading) {
    formLoading.classList.add('hidden');
    
    // Remove from DOM after animation
    setTimeout(() => {
      formLoading.remove();
    }, 500);
  }
}, 100);

// Start monitoring for external interference
monitorPriceDisplay();

// console.log(('✅ All initialization complete');
  }, 100);
}







// Apply metafield overrides safely (targets visible radios)
function applySfOverrides() {
  const m = { ...(window.sfOverrides || {}), ...readMetafieldOverrides() };
  const val  = x => (Array.isArray(x) ? x[0] : x) || '';
  const norm = s => String(s).trim().toLowerCase();

  const targetType  = norm(val(m.productType));   // 'custom sticker' | 'custom label'
  const targetShape = String(val(m.shape)).trim(); // e.g. 'Oval'
  const targetMat   = String(val(m.material || '')).trim();
  const targetSize  = String(val(m.size || '')).trim();
  const targetQty   = String(val(m.qty || '')).trim();

  // 1) product type
  const idPT = (targetType === 'custom label') ? 'custom-label' : 'custom-sticker';
  const ptEl = document.getElementById(idPT);
  if (ptEl) { ptEl.checked = true; ptEl.dispatchEvent(new Event('change',{bubbles:true})); }
  if (typeof toggleProductType === 'function') toggleProductType();

  // helpers
  const visible = el => el && !el.disabled && el.offsetParent !== null;
  const pickByValue = (name, value) => {
    const sel = `input[name="${name}"]`;
    const list = Array.from(document.querySelectorAll(sel));
    return list.find(i => visible(i) && String(i.value).trim().toLowerCase() === String(value).trim().toLowerCase());
  };
  const normalizeSelectValue = value => String(value || '')
    .toLowerCase()
    .replace(/["'\s]/g, '')
    .replace(/×/g, 'x');
  const setSelectByOverride = (select, value) => {
    if (!select || !value) return false;
    const wanted = normalizeSelectValue(value);
    const option = Array.from(select.options || []).find(opt =>
      normalizeSelectValue(opt.value) === wanted ||
      normalizeSelectValue(opt.textContent) === wanted
    );
    if (!option) return false;
    select.value = option.value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };
  const applySizeQtyOverrides = () => {
    const isLabel = (document.querySelector('input[name="product-type"]:checked')?.value === 'Custom Label')
      || (targetType === 'custom label');
    if (isLabel) {
      const shapeNow = String(document.querySelector('input[name="properties[Label Shape]"]:checked')?.value || targetShape).trim();
      const labelSizeId = {
        Circle: 'select-size-circle-label',
        Square: 'select-size-square-label',
        Oval: 'select-size-oval-label',
        Rectangle: 'select-size-rectangle-label'
      }[shapeNow];
      setSelectByOverride(document.getElementById(labelSizeId), targetSize);
      setSelectByOverride(document.getElementById('label-quantity'), targetQty);
    } else {
      setSelectByOverride(document.getElementById('select-size-sticker'), targetSize);
      setSelectByOverride(document.getElementById('sticker-quantity'), targetQty);
    }
  };

  // 2) shape (checks both groups, prefers visible one)
  const shapeEl =
    pickByValue('properties[Select Your Shape]', targetShape) ||
    pickByValue('properties[Label Shape]',       targetShape);
  if (shapeEl) {
    shapeEl.checked = true;
    shapeEl.dispatchEvent(new Event('input',{bubbles:true}));
    shapeEl.dispatchEvent(new Event('change',{bubbles:true}));
  }

// 3) material (optional metafield)
if (targetMat) {
  const isLabel = (document.querySelector('input[name="product-type"]:checked')?.value === 'Custom Label')
               || (targetType === 'custom label');

  const pool = isLabel
    ? [...document.querySelectorAll('input[name="properties[Label Material]"]')]
    : [...document.querySelectorAll('input[name="properties[Select Your Material]"]')];

  const matEl = pool.find(el =>
    !el.disabled &&
    el.offsetParent !== null && // only visible set (CS vs OR)
    norm(el.value) === norm(targetMat)
  );

  if (matEl) {
    matEl.checked = true;
    matEl.dispatchEvent(new Event('change', { bubbles:true }));
  }
}

  applySizeQtyOverrides();

  if (typeof updatePriceDisplay === 'function') updatePriceDisplay();

  // Re-assert a couple of times to beat late scripts
  [80, 250, 600].forEach(t => setTimeout(() => {
    // product type again (if UI toggled)
    if (ptEl && !ptEl.checked) { ptEl.checked = true; ptEl.dispatchEvent(new Event('change',{bubbles:true})); }
    if (shapeEl && !shapeEl.checked) {
      shapeEl.checked = true;
      shapeEl.dispatchEvent(new Event('change',{bubbles:true}));
    }
    applySizeQtyOverrides();
    if (typeof updatePriceDisplay === 'function') updatePriceDisplay();
  }, t));
}





// Wait for DOM to be ready, then initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProductCustomizer);
} else {
  // DOM is already ready
  initializeProductCustomizer();
}









 
// this code is for customizer modal button overlay

// Listen for design completion from customizer

window.addEventListener('message', function(event) {
  if (event.data && event.data.type === 'DESIGN_COMPLETE') {
    const designData = event.data.data;
    window.customDesignData = designData;
    if (designData?.image) {
      const designInput = document.getElementById('designDataInput');
      if (designInput) designInput.value = designData.image;
    }
    
    // Close modal
    const customizerModal = document.getElementById('customizerModal');
    const customizerFrame = document.getElementById('customizerFrame');
    if (customizerModal && customizerFrame) {
      customizerModal.style.display = 'none';
      customizerFrame.src = '';
    }
    
    // ADD THIS LINE ONLY:
    updateStep2UploadSection();
    syncBuilderExperience();
    
    // Show banner instead of alert
    showDesignReadyBanner();
    document.getElementById('upload-design-btn').textContent = 'Proceed to Cart';
  }
});


// Create and show design ready banner
function showDesignReadyBanner() {
  // Remove existing banner if any
  const existingBanner = document.getElementById('design-ready-banner');
  if (existingBanner) existingBanner.remove();
  
  // Create banner
  const banner = document.createElement('div');
  banner.id = 'design-ready-banner';
  banner.className = 'design-ready-banner';
  banner.innerHTML = `
    <div class="banner-content">
      <span class="banner-text">✅ Your custom design is ready! Review your settings below and proceed to checkout.</span>
      <button class="clear-design-btn" onclick="clearCustomDesign()">Clear Design</button>
    </div>
  `;
  
  // Insert at top of form container
  const formContainer = document.querySelector('.product-form-container');
  if (formContainer) {
    formContainer.insertBefore(banner, formContainer.firstChild);
  }
  
  // Scroll to top smoothly
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

// Clear design function





function clearCustomDesign() {
  delete window.customDesignData;
  const designInput = document.getElementById('designDataInput');
  if (designInput) designInput.value = '';
  localStorage.removeItem('stickerfreaks_design');
  document.getElementById('design-ready-banner')?.remove();
  updateStep2UploadSection(); 
  handleFileUpload();
  handleEmailArtwork();
  syncBuilderExperience();
  document.getElementById('upload-design-btn').textContent = 'Upload Your Design';
}




// Check and update Step 2 upload section
function updateStep2UploadSection() {
  const uploadSection = document.querySelector('.sf-upload-artwork-box, div[style*="border: 5px solid #1EB0E4"]');
  if (!uploadSection) return;
  const previewShape = getSfCurrentProductPreviewShape();
  const previewMaskClass = getSfMaskClass(previewShape);
  
  // Check for uploaded file
  const fileInput = document.getElementById('file-select-quantity');
  const hasUploadedFile = fileInput && fileInput.files && fileInput.files[0];
  
  // PRIORITY: Custom design always wins over uploaded file
  if (window.customDesignData) {
    // Clear any uploaded file if custom design exists
    if (hasUploadedFile) {
      fileInput.value = '';
    }
    
    // Show custom design preview
    uploadSection.innerHTML = `
      <div class="sf-artwork-ready">
        <h2>🔷 Your Custom Design</h2>
        <div class="sf-artwork-preview-wrap ${previewMaskClass}">
          <img src="${window.customDesignData.image}" alt="Your Design" />
        </div>
        <div class="sf-artwork-actions">
          <button type="button" onclick="editCustomDesign()" class="sf-artwork-action sf-artwork-action-primary">Edit Design</button>
          <button type="button" onclick="removeCustomDesignStep2()" class="sf-artwork-action sf-artwork-action-danger">Remove Design</button>
        </div>
        <p class="sf-artwork-meta">
          <strong>Design Details:</strong> ${window.customDesignData.shape} shape, ${
            window.customDesignData.backgroundFile ? window.customDesignData.backgroundName : 'color'
          }
        </p>
        <div class="sf-artwork-submit">
          <button id="add-to-cart-btn" class="button btn-design">Checkout</button>
        </div>
      </div>
    `;
    
  } else if (hasUploadedFile) {
    // Show uploaded file preview
    const file = fileInput.files[0];
    const fileURL = URL.createObjectURL(file);
    
    uploadSection.innerHTML = `
      <div class="sf-artwork-ready">
        <h2>🔷 Your Uploaded Design</h2>
        <div class="sf-artwork-preview-wrap ${previewMaskClass}">
          <img src="${fileURL}" alt="Your Design" />
        </div>
        <div class="sf-artwork-actions">
          <button type="button" onclick="reuploadFile()" class="sf-artwork-action sf-artwork-action-secondary">Re-upload</button>
          <button type="button" onclick="openStickerFreaksCustomizer()" class="sf-artwork-action sf-artwork-action-primary">Edit in Design Tool</button>
          <button type="button" onclick="removeUploadedFile()" class="sf-artwork-action sf-artwork-action-danger">Remove</button>
        </div>
        <p class="sf-artwork-meta">
          <strong>File:</strong> ${file.name}
        </p>
        <div class="sf-artwork-submit">
          <button id="add-to-cart-btn" class="button btn-design">Checkout</button>
        </div>
      </div>
    `;
    
  } else {
    // Show normal upload section with customizer button
    uploadSection.innerHTML = `
      <div style="text-align: center;">
        <h2>🔷 Choose Your Design Method</h2>
        <p style="color: #666; margin-bottom: 25px;">Create a custom design or upload your own artwork</p>
        
        <div class="file-upload-container">
          <button id="button-select-quantity" class="button btn-design" type="button" 
                  style="padding: 15px 20px; width: 100%; font-size: 16px; font-weight: bold;">
            <span class="sf-upload-icon" aria-hidden="true">⬆️</span>
            <span class="sf-upload-main">Drag &amp; drop your file, or <strong>click to browse</strong></span>
            <span class="sf-upload-hint">AI · EPS · PDF · PNG · JPG · TIFF · SVG &nbsp;·&nbsp; Max 10 MB</span>
          </button>
          <span id="file-name-display" style="margin-left: 10px; font-style: italic; color: #666; font-size: 14px;"></span>
        </div>

        <div class="or-divider" style="text-align: center; margin: 25px 0; position: relative;">
          <span style="background: rgba(255, 255, 255, 0.9); padding: 0 20px; color: #666; font-weight: bold; font-size: 18px;">or</span>
          <hr style="position: absolute; top: 50%; left: 0; right: 0; z-index: -1; border: none; border-top: 3px solid #ddd; display: block !important;">
        </div>

        <div class="button-container" style="display: block; margin-bottom: 20px;">
          <button id="launchCustomizerBtn" type="button" class="button btn-design" 
                  style="padding: 15px 20px; width: 100%; font-size: 16px; font-weight: bold;">
            <span class="sf-tool-icon" aria-hidden="true">🎨</span>
            <span>Use our free online design tool</span>
          </button>
        </div>

        <!-- File Info -->
        <div style="margin-bottom: 20px; color: #666; font-size: 14px;">
          <span>Accepted formats: .ai, .eps, .jpg, .png, .pdf, .tiff, .svg • Minimum 300 dpi</span>
          <p id="errorMessage" class="error-message" style="display: none; margin-top: 8px; color: red;">Please upload your file(s).</p>
        </div>
      </div>

      <!-- Email Later Option -->
      <div style="margin-top: 20px; padding: 15px; background: #f9f9f9; border-radius: 8px;">
        <div class="field custom-checkbox">
          <input type="checkbox" id="email-your-artwork-later">
          <label style="margin-left: 5px; margin-bottom: 0; font-size: 20px;" class="form__label" for="email-your-artwork-later">I'll email my artwork later</label><br>
        </div>
        <div id="instructions-container" style="display: none;">
          <label class="form__label custom" for="instructions-text">Instructions (Optional)</label>
          <div class="field custom">
            <textarea class="text-area field__input" id="instructions-text" rows="5"></textarea>
          </div>
        </div>
      </div>

      <!-- Checkout Button -->
      <div style="margin-top: 20px; text-align: center;">
        <button id="add-to-cart-btn" class="button btn-design" style="padding: 15px; width: 100%; border: 0; border-radius: 8px; font-weight: bold;">Checkout</button>
      </div>
    `;
  }
  handleFileUpload();
  handleEmailArtwork();
  syncBuilderExperience();




// Product page JS (same file as updateStep2UploadSection)

// Robust closer to handle dialog/drawer/overlay
function closeCustomizerModal() {
  // <dialog id="customizerModal">
  var dlg = document.getElementById('customizerModal');
  if (dlg) {
    if (typeof dlg.close === 'function') dlg.close();
    dlg.style.display = 'none';
  }

  // Class-based overlays
  var overlay = document.querySelector('[data-customizer-overlay]');
  if (overlay) overlay.classList.remove('open','is-active','active','show');

  // Common body/html locks
  document.documentElement.classList.remove('modal-open');
  document.body.classList.remove('modal-open','overflow-hidden');

  // Fallback: click any known close button
  var btn = document.querySelector('[data-action="customizer-close"],[data-testid="customizer-close"],.customizer-close');
  if (btn) btn.click();
}

// Listen for save from iframe; update preview and close modal
window.addEventListener('message', function (ev) {
  if (!ev || !ev.data || ev.data.type !== 'SF_DESIGN_SAVED') return;

  // Keep globally for your step UI
  window.customDesignData = ev.data.data;
  if (window.customDesignData?.image) {
    const designInput = document.getElementById('designDataInput');
    if (designInput) designInput.value = window.customDesignData.image;
  }

  // Immediately refresh Step 2 UI into preview mode
  if (typeof updateStep2UploadSection === 'function') {
    updateStep2UploadSection();
  }
  syncBuilderExperience();

  // Close the modal silently (no message page)
  closeCustomizerModal();
});




  // RE-ATTACH EVENT LISTENERS - COMPLETE IMPLEMENTATION
  // Re-attach Add to Cart functionality with full logic
  const addToCartBtn = document.getElementById('add-to-cart-btn');
  if (addToCartBtn && !window.sfAddToCartDelegated) {
    addToCartBtn.addEventListener('click', async function(e) {
      e.preventDefault();
      
      // Validation - check for custom design OR file upload OR email later
      const fileSelectQuantity = document.getElementById('file-select-quantity');
      const emailLaterCheckbox = document.getElementById('email-your-artwork-later');
      
      // Check if custom design exists OR file uploaded OR email later checked
      const hasCustomDesign = Boolean(window.customDesignData?.image || window.sfV3ArtworkData?.image || document.getElementById('designDataInput')?.value);
      const hasFile = fileSelectQuantity && fileSelectQuantity.files && fileSelectQuantity.files.length > 0;
      const emailLater = emailLaterCheckbox && emailLaterCheckbox.checked;
      
      if (!hasCustomDesign && !hasFile && !emailLater) {
        alert('Please upload your artwork file, use the custom designer, or check "Email your artwork later"');
        return;
      }
      
      // Get calculated price
      const price = calculatePrice();
      if (!price || price <= 0) {
        alert('Please configure your product options');
        return;
      }
      
      setSfCheckoutLoading(true);
      const sfCheckoutClientStart = performance.now();
      
      // Collect all form data
      const formData = new FormData();
      
      // Add calculated price
      formData.append('calculated_price', price);
      
      // Add ONLY relevant form fields based on product type
      const form = document.getElementById('product-form');
      const productType = getSfBuilderProductType();
      setSfProductTypeVariant(formData, productType);

      // Add product type FIRST so it appears at the top
      if (productType) {
        formData.append('Product_Type', productType);
      }
      // Deal-mode: force size/qty from metafields for display/payload
      const ovr = { ...readMetafieldOverrides(), ...(window.sfOverrides || {}) };
      if (ovr.size) { formData.set('Final Size', String(ovr.size)); }
      if (ovr.qty)  { formData.set('Quantity', String(ovr.qty)); }


// Handle custom design data - old customizer or v3 editor preview
const sfArtworkPrepStart = performance.now();
const hasCustomDesignPayload = await appendSfCustomDesignData(formData);

      // Simple file upload (only if no custom design)
      if (!hasCustomDesignPayload) {
        await appendSfArtworkFiles(formData);
      }
      formData.set('SF_Client_Artwork_Prep_Ms', String(Math.round(performance.now() - sfArtworkPrepStart)));

if (form && productType) {
       const inputs = form.querySelectorAll('input, select, textarea');
       inputs.forEach(function(input) {
         if (input.name && input.name.startsWith('properties[') && !input.disabled) {
           let propertyName = input.name.replace('properties[', '').replace(']', '');
           
           // Filter based on product type
           let shouldInclude = false;
           
           if (productType === 'Custom Sticker') {
             // Only include sticker-related fields
             if (propertyName === 'Select Your Shape' || 
                 propertyName === 'Select Size' ||
                 propertyName === 'Select Your Material' || 
                 propertyName === 'Enhance Image Quality' || 
                 propertyName === 'Quantity' ||
                 propertyName === 'Email your artwork later' ||
                 propertyName === 'Instructions (Optional)') {
               shouldInclude = true;
               
               // Clean up property names for stickers
               if (propertyName === 'Select Your Shape') propertyName = 'Sticker Shape';
               if (propertyName === 'Select Size') propertyName = 'Sticker Size';
               if (propertyName === 'Select Your Material') propertyName = 'Sticker Material';
               
               // Deal mode: use metafield values instead of form values
               const ovr = { ...window.sfOverrides, ...readMetafieldOverrides() };
              if (sfTruthyValue(ovr.dealMode)) {
                 if (propertyName === 'Sticker Size' && ovr.size) {
                   formData.append(propertyName, String(ovr.size));
                   return; // Skip the normal form value collection
                 }
                 if (propertyName === 'Quantity' && ovr.qty) {
                   formData.append(propertyName, String(ovr.qty));
                   return; // Skip the normal form value collection
                 }
               }
             }
           } else if (productType === 'Custom Label') {
             // Only include label-related fields
             if (propertyName.includes('Label') || 
                 propertyName === 'Enhance Image Quality' || 
                 propertyName === 'Quantity' ||
                 propertyName === 'Email your artwork later' ||
                 propertyName === 'Instructions (Optional)') {
               shouldInclude = true;
               
               // Clean up property names for labels
               if (propertyName === 'Label Shape') propertyName = 'Label Shape';
               if (propertyName === 'Label Size') propertyName = 'Label Size';
               if (propertyName === 'Label Material') propertyName = 'Label Material';
               
               // Deal mode: use metafield values instead of form values
               const ovr = { ...window.sfOverrides, ...readMetafieldOverrides() };
              if (sfTruthyValue(ovr.dealMode)) {
                 if (propertyName === 'Label Size' && ovr.size) {
                   formData.append(propertyName, String(ovr.size));
                   return; // Skip the normal form value collection
                 }
                 if (propertyName === 'Quantity' && ovr.qty) {
                   formData.append(propertyName, String(ovr.qty));
                   return; // Skip the normal form value collection
                 }
               }
             }
           }

           // Handle label size collection for labels (only if NOT in deal mode)
           if (productType === 'Custom Label') {
             const ovr = { ...window.sfOverrides, ...readMetafieldOverrides() };
            if (!sfTruthyValue(ovr.dealMode)) {
               const shape = document.querySelector('input[name="properties[Label Shape]"]:checked')?.value;
               let labelSizeValue = '';
               let labelSizeName = '';

               if (shape === 'Circle') {
                   const sizeSelect = document.getElementById('select-size-circle-label');
                   if (sizeSelect && sizeSelect.value) {
                       labelSizeValue = sizeSelect.value + '"';
                       labelSizeName = 'Label Size';
                   }
               } else if (shape === 'Square') {
                   const sizeSelect = document.getElementById('select-size-square-label');
                   if (sizeSelect && sizeSelect.value) {
                       labelSizeValue = sizeSelect.value + '"';
                       labelSizeName = 'Label Size';
                   }
               } else if (shape === 'Oval') {
                   const sizeSelect = document.getElementById('select-size-oval-label');
                   if (sizeSelect && sizeSelect.value) {
                       labelSizeValue = sizeSelect.value;
                       labelSizeName = 'Label Size';
                   }
               } else if (shape === 'Rectangle') {
                   const sizeSelect = document.getElementById('select-size-rectangle-label');
                   if (sizeSelect && sizeSelect.value) {
                       labelSizeValue = sizeSelect.value;
                       labelSizeName = 'Label Size';
                   }
               }

               // Set the label size in form data
               if (labelSizeValue && labelSizeName) {
                   formData.set(labelSizeName, labelSizeValue);
               }
             }
           }
           
           if (shouldInclude) {
             if (input.type === 'checkbox' || input.type === 'radio') {
               if (input.checked) {
                 formData.append(propertyName, input.value || 'Yes');
               }
            } else if (input.type === 'file') {
              return;
} else if (input.value) {
  // Special handling for Quantity to avoid duplicate collection
  if (propertyName === 'Quantity') {
    // Only collect from the correct quantity selector based on product type
    if ((productType === 'Custom Sticker' && input.id === 'sticker-quantity') ||
        (productType === 'Custom Label' && input.id === 'label-quantity')) {
      formData.append(propertyName, input.value);
    }
  } else {
    formData.append(propertyName, input.value);
  }
}
           }
         }
       });
     }
      // Add custom size if selected
      const sizeSelect = document.getElementById('select-size-sticker');
      if (sizeSelect && sizeSelect.value === 'Custom Size') {
        const customWidth = document.getElementById('custom-width-input');
        const customHeight = document.getElementById('custom-height-input');
        
        if (customWidth && customHeight && customWidth.value && customHeight.value) {
          formData.append('Final Size', `${customWidth.value}" x ${customHeight.value}"`);
        }
      }

      appendSfServerPricingFields(formData, productType);
      formData.set('SF_Client_Payload_Ready_Ms', String(Math.round(performance.now() - sfCheckoutClientStart)));

      // Send to your API
      fetch(getDraftOrderEndpoint(), {
        method: 'POST',
        body: formData,
      })
      .then(response => response.json())
      .then(data => {
        if (data.success && data.invoice_url) {
          // Success! Redirect to Shopify checkout
          window.location.href = data.invoice_url;
        } else {
          // Error occurred
          console.error('API Error:', data);
          const detailText = data.pricing_details
            ? Object.entries(data.pricing_details)
                .filter(([, value]) => value !== null && value !== '' && typeof value !== 'undefined')
                .map(([key, value]) => `${key}: ${value}`)
                .join('\n')
            : '';
          alert(`${data.error || 'Something went wrong. Please try again.'}${detailText ? `\n\nPricing details:\n${detailText}` : ''}`);
          
          resetSfCheckoutLoading();
        }
      })
      .catch(error => {
        console.error('Network Error:', error);
        alert('Network error. Please check your connection and try again.');
        resetSfCheckoutLoading();
      });
    });
  }
  
  // Re-attach file upload functionality  
  handleFileUpload();
  handleEmailArtwork();
}





  // Re-upload function
function reuploadFile() {
  const fileInput = document.getElementById('file-select-quantity');
  if (fileInput) {
    fileInput.click();
  }
}

// Remove uploaded file function
function removeUploadedFile() {
  const fileInput = document.getElementById('file-select-quantity');
  if (fileInput) {
    fileInput.value = '';
  }
  updateStep2UploadSection();
  syncBuilderExperience();
}




function getStickerFreaksCustomizerUrl() {
  const productType = document.querySelector('input[name="product-type"]:checked')?.value || 'Custom Sticker';
  const shapeInput = document.querySelector(
    productType === 'Custom Label'
      ? 'input[name="properties[Label Shape]"]:checked'
      : 'input[name="properties[Select Your Shape]"]:checked'
  );
  const selectedShape = (shapeInput?.value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-');

  const url = new URL('https://customizer.stickerfreaksllc.com/');
  if (selectedShape) url.searchParams.set('shape', selectedShape);
  if (productType === 'Custom Label') url.searchParams.set('mode', 'label');
  return url.toString();
}

function openStickerFreaksCustomizer() {
  const customizerModal = document.getElementById('customizerModal');
  const customizerFrame = document.getElementById('customizerFrame');
  if (!customizerModal || !customizerFrame) {
    console.error('Customizer modal elements not found');
    return;
  }

  customizerFrame.src = getStickerFreaksCustomizerUrl();
  customizerModal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

window.openStickerFreaksCustomizer = openStickerFreaksCustomizer;

// Edit design function
function editCustomDesign() {
  openStickerFreaksCustomizer();
}

// Remove design function
function removeCustomDesign() {
  delete window.customDesignData;
  const designInput = document.getElementById('designDataInput');
  if (designInput) designInput.value = '';
  localStorage.removeItem('stickerfreaks_design');
  document.getElementById('design-ready-banner').remove();
  updateStep2UploadSection();
  syncBuilderExperience();
  updateButtonText();
}


// Watch for when Step 2 becomes visible
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    const nextStepSection = document.getElementById('next-step-section');
    if (nextStepSection && nextStepSection.style.display !== 'none') {
      // Step 2 is now visible, update the upload section
      updateStep2UploadSection();
      syncBuilderExperience();
    }
  });
});

// Start observing
observer.observe(document.getElementById('next-step-section'), {
  attributes: true,
  attributeFilter: ['style']
});




// Remove design function specifically for Step 2
function removeCustomDesignStep2() {
  delete window.customDesignData;
  const designInput = document.getElementById('designDataInput');
  if (designInput) designInput.value = '';
  localStorage.removeItem('stickerfreaks_design');
  
  // Remove banner if it exists
  const banner = document.getElementById('design-ready-banner');
  if (banner) banner.remove();
  
  // Update Step 2 to show upload section
  updateStep2UploadSection();
  syncBuilderExperience();
  
  // Update button text back to "Upload Your Design"
  document.getElementById('upload-design-btn').textContent = 'Upload Your Design';
}






 
